export default {
    "報名會友": "報名會友",
    "選填，綁定後該會友可在 App 查看此報名與報到條碼": "選填，綁定後該會友可在 App 查看此報名與報到條碼",
    "尚未指定會友": "尚未指定會友",
    "選擇會友": "選擇會友",
    "未綁定會友": "未綁定會友",
    "搜尋名單": "搜尋名單",
    "搜尋範圍: 名字/郵件": "搜尋範圍: 名字/郵件",
    "族群名稱": "族群名稱",
    "請輸入族群名稱": "請輸入族群名稱",
    "所屬族群": "所屬族群",
    "請選擇所屬族群": "請選擇所屬族群",
    "關閉": "關閉",
    "確定": "確定",
    "最少需要選擇幾位族群成員": "最少需要選擇 %s 位族群成員",
    "最少需要選擇幾位託管人員": "最少需要選擇 %s 位託管人員",
    "最多只能選擇幾位託管人員": "最多只能選擇 %s 位託管人員",
    "尚未異動項目": "尚未異動項目",
    "成員種類1": "族群成員",
    "成員種類2": "託管人員",
    "可選擇幾個會友": "可選擇 <b class=\"cgBase\">%s</b> 個會友",
    "請選擇加入的項目": "請選擇加入的項目",
    "加入": "加入",
    "移除": "移除",
    "已選擇幾位族群成員": "已選擇 <b class=\"cgBase\">%s</b> 位族群成員",
    "已選擇幾位託管人員": "已選擇 <b class=\"cgBase\">%s</b> 位託管人員",
    "相關資訊": "相關資訊",
    "基本:": "基本:",
    "團報": "團報",
    "表單": "表單",
    "金流": "金流",
    "報名人員": "報名人員",
    "報名時間": "報名時間",
    "重設": "重設",
    "立即更新": "立即更新",
    "聚會開始時間": "聚會開始時間",
    "請選擇開始時間": "請選擇開始時間",
    "首次聚會開始時間": "首次聚會開始時間",
    "聚會結束時間": "聚會結束時間",
    "請選擇結束時間": "請選擇結束時間",
    "首次聚會結束時間": "首次聚會結束時間",
    "資訊公開時間": "資訊公開時間",
    "資訊隱藏時間": "資訊隱藏時間",
    "聚會時間": "聚會時間",
    "發送聚會的起始效期": "發送聚會的起始效期",
    "發送聚會的結束效期": "發送聚會的結束效期",
    "聚會僅在「資訊公開時間」至「資訊隱藏時間」之間發送，未在此期間不會發送": "聚會僅在「資訊公開時間」至「資訊隱藏時間」之間發送，未在此期間不會發送",
    "套用於資訊公開／隱藏日期": "套用於資訊公開／隱藏日期",
    "請選擇資訊公開時間": "請選擇資訊公開時間",
    "請選擇資訊隱藏時間": "請選擇資訊隱藏時間",
    "請選擇聚會時間": "請選擇聚會時間",
    "資訊公開時間不可晚於資訊隱藏時間": "資訊公開時間不可晚於資訊隱藏時間",
    "系統已經推播完成，無法編輯或刪除": "系統已經推播完成，無法編輯或刪除",
    "系統已經正在推播，無法編輯或刪除": "系統已經正在推播，無法編輯或刪除",
    "標題": "標題",
    "請輸入標題": "請輸入標題",
    "上架時間": "上架時間",
    "下架時間": "下架時間",
    "外部活動連結": "外部活動連結",
    "請輸入外部活動連結": "請輸入外部活動連結",
    "Youtube連結": "Youtube連結",
    "請輸入Youtube連結": "請輸入Youtube連結",
    "Google雲端MP3": "Google雲端MP3",
    "請輸入Google雲端MP3": "請輸入Google雲端MP3",
    "直播連結": "直播連結",
    "請輸入直播連結": "請輸入直播連結",
    "外部網站連結": "外部網站連結",
    "請輸入外部網站連結": "請輸入外部網站連結",
    "觀看": "觀看",
    "外連": "外連",
    "留言": "留言",
    "推播": "推播",
    "排程": "排程",
    "類型": "類型",
    "置頂": "置頂",
    "封面圖": "封面圖",
    "操作": "操作",
    "狀態": "狀態",
    "建立時間": "建立時間",
    "建立者": "建立者",
    "編輯者": "編輯者",
    "編輯時間": "編輯時間",
    "管理員啟用成功": "管理員啟用成功",
    "管理員停用成功": "管理員停用成功",
    "管理員刪除成功": "管理員刪除成功",
    "如果不需要變更密碼，不用填寫": "如果不需要變更密碼，不用填寫",
    "變更密碼": "變更密碼",
    "目前當前密碼": "目前當前密碼",
    "請輸入目前當前密碼": "請輸入目前當前密碼",
    "登入密碼": "登入密碼",
    "請輸入登入密碼": "請輸入登入密碼",
    "確認登入密碼": "確認登入密碼",
    "請再次輸入登入密碼進行確認": "請再次輸入登入密碼進行確認",
    "頭像": "頭像",
    "帳號": "帳號",
    "請輸入帳號": "請輸入帳號",
    "名字": "名字",
    "請輸入名字": "請輸入名字",
    "電子郵件": "電子郵件",
    "請輸入電子郵件": "請輸入電子郵件",
    "電話": "電話",
    "請輸入聯絡電話": "請輸入聯絡電話",
    "推播說明文字": "推播說明文字",
    "請輸入推播說明文字": "請輸入推播說明文字",
    "地點": "地點",
    "請輸入地點": "請輸入地點",
    "請選擇狀態": "請選擇狀態",
    "服事資訊": "服事資訊",
    "請輸入服事資訊": "請輸入服事資訊",
    "報名": "報名",
    "場次": "場次",
    "簽到": "簽到",
    "回條": "回條",
    "欄位": "欄位",
    "提醒": "提醒",
    "文章": "文章",
    "圖片": "圖片",
    "分享": "分享",
    "封面圖尺寸": "(尺寸為 %sx%s 像素)",
    "指定教會": "指定教會",
    "分類": "分類",

    // ---- 以下由 zhTW.output 自動匯入 (Phase 1, 2026-05-15) ----
    "我的教會": "我的教會",
    "牧養系統": "牧養系統",
    "心靈捕手": "心靈捕手",
    "每日靈糧": "每日靈糧",
    "公吿欄": "公吿欄",
    "公吿內容": "公吿內容",
    "控制面板": "控制面板",
    "會友人數": "會友人數",
    "會友新增": "會友新增",
    "會友刪除": "會友刪除",
    "上稿次數": "上稿次數",
    "發送推播": "發送推播",
    "聖經開啟": "聖經開啟",
    "收藏次數": "收藏次數",
    "留言次數": "留言次數",
    "分享次數": "分享次數",
    "文章觀看": "文章觀看",
    "外連觀看": "外連觀看",
    "登入次數": "登入次數",
    "公吿管理": "公吿管理",
    "公吿新增": "公吿新增",
    "管理員帳號管理": "管理員帳號管理",
    "管理員新增": "管理員新增",
    "管理員內容": "管理員內容",
    "教會管理": "教會管理",
    "教會新增": "教會新增",
    "教會內容": "教會內容",
    "會友管理": "會友管理",
    "會友內容": "會友內容",
    "奉獻紀錄": "奉獻紀錄",
    "奉獻內容": "奉獻內容",
    "會友管理-奉獻紀錄": "會友管理 - 奉獻紀錄",
    "我的教會文章管理": "我的教會文章管理",
    "我的教會文章新增": "我的教會文章新增",
    "我的教會文章內容": "我的教會文章內容",
    "文章複製": "文章複製",
    "文章導入": "文章導入",
    "留言紀錄": "留言紀錄",
    "我的教會文章管理-留言紀錄": "我的教會文章管理 - 留言紀錄",
    "推播紀錄": "推播紀錄",
    "推播新增": "推播新增",
    "推播內容": "推播內容",
    "我的教會文章管理-推播紀錄": "我的教會文章管理 - 推播紀錄",
    "每日靈糧文章管理": "每日靈糧文章管理",
    "每日靈糧文章新增": "每日靈糧文章新增",
    "每日靈糧文章內容": "每日靈糧文章內容",
    "每日靈糧文章管理-留言紀錄": "每日靈糧文章管理 - 留言紀錄",
    "新增推播": "新增推播",
    "每日靈糧文章管理-推播紀錄": "每日靈糧文章管理 - 推播紀錄",
    "心靈捕手文章管理": "心靈捕手文章管理",
    "心靈捕手文章新增": "心靈捕手文章新增",
    "心靈捕手文章內容": "心靈捕手文章內容",
    "心靈捕手文章管理-文章管理": "心靈捕手文章管理 - 文章管理",
    "心靈捕手文章管理-留言紀錄": "心靈捕手文章管理 - 留言紀錄",
    "心靈捕手文章管理-推播紀錄": "心靈捕手文章管理 - 推播紀錄",
    "心靈捕手分類管理": "心靈捕手分類管理",
    "心靈捕手文章管理-分類管理": "心靈捕手文章管理 - 分類管理",
    "圖庫管理": "圖庫管理",
    "圖庫清單": "圖庫清單",
    "圖庫核准": "圖庫核准",
    "圖庫檢舉": "圖庫檢舉",
    "圖庫管理-圖庫清單": "圖庫管理 - 圖庫清單",
    "圖庫管理-圖庫核准": "圖庫管理 - 圖庫核准",
    "圖庫管理-圖庫檢舉": "圖庫管理 - 圖庫檢舉",
    "推播管理": "推播管理",
    "自動化紀錄": "自動化紀錄",
    "紀錄內容": "紀錄內容",
    "行事曆管理": "行事曆管理",
    "教會行事曆": "教會行事曆",
    "行事曆管理-教會行事曆": "行事曆管理 - 教會行事曆",
    "複製服事": "複製服事",
    "服事新增": "服事新增",
    "服事內容": "服事內容",
    "服事清單": "服事清單",
    "行事曆管理-服事清單": "行事曆管理 - 服事清單",
    "服事群組": "服事群組",
    "群組新增": "群組新增",
    "群組內容": "群組內容",
    "行事曆管理-服事群組": "行事曆管理 - 服事群組",
    "歷史紀錄": "歷史紀錄",
    "奉獻管理": "奉獻管理",
    "循環管理": "循環管理",
    "循環新增": "循環新增",
    "循環內容": "循環內容",
    "循環紀錄": "循環紀錄",
    "教學管理": "教學管理",
    "教學新增": "教學新增",
    "教學內容": "教學內容",
    "問題集管理": "問題集管理",
    "問題群組": "問題群組",
    "問題集新增": "問題集新增",
    "問題集內容": "問題集內容",
    "問題集管理-問題群組": "問題集管理 - 問題群組",
    "問題設置": "問題設置",
    "問題設置新增": "問題設置新增",
    "設置內容": "設置內容",
    "問題集管理-問題設置": "問題集管理 - 問題設置",
    "回覆選項": "回覆選項",
    "回覆選項新增": "回覆選項新增",
    "選項內容": "選項內容",
    "問題集管理-回覆選項": "問題集管理 - 回覆選項",
    "表單紀錄": "表單紀錄",
    "問題集管理-表單紀錄": "問題集管理 - 表單紀錄",
    "客服管理": "客服管理",
    "紀錄新增": "紀錄新增",
    "異動紀錄": "異動紀錄",
    "帳號紀錄": "帳號紀錄",
    "客服管理-帳號紀錄": "客服管理 - 帳號紀錄",
    "意見與建議": "意見與建議",
    "反饋內容": "反饋內容",
    "客服管理-意見與建議": "客服管理 - 意見與建議",
    "請我們喝咖啡": "請我們喝咖啡",
    "贊助內容": "贊助內容",
    "客服管理-請我們喝咖啡": "客服管理 - 請我們喝咖啡",
    "歷程管理": "歷程管理",
    "攔截紀錄": "攔截紀錄",
    "攔截內容": "攔截內容",
    "歷程管理-攔截紀錄": "歷程管理 - 攔截紀錄",
    "存取紀錄": "存取紀錄",
    "存取內容": "存取內容",
    "歷程管理-存取紀錄": "歷程管理 - 存取紀錄",
    "授權紀錄": "授權紀錄",
    "登入內容": "登入內容",
    "歷程管理-授權紀錄": "歷程管理 - 授權紀錄",
    "活動管理": "活動管理",
    "活動清單": "活動清單",
    "活動新增": "活動新增",
    "活動內容": "活動內容",
    "後台報名": "後台報名",
    "報名清單": "報名清單",
    "報名內容": "報名內容",
    "活動管理-活動清單": "活動管理 - 活動清單",
    "分類管理": "分類管理",
    "分類新增": "分類新增",
    "分類內容": "分類內容",
    "活動管理-分類管理": "活動管理 - 分類管理",
    "直播管理": "直播管理",
    "直播清單": "直播清單",
    "直播新增": "直播新增",
    "直播內容": "直播內容",
    "聊天室發言": "聊天室發言",
    "私密代禱": "私密代禱",
    "直播管理-直播清單": "直播管理 - 直播清單",
    "直播管理-分類管理": "直播管理 - 分類管理",
    "個人資訊": "個人資訊",
    "新朋友數量": "新朋友數量",
    "已跟進會友": "已跟進會友",
    "未跟進會友": "未跟進會友",
    "不跟進會友": "不跟進會友",
    "族群數量": "族群數量",
    "聚會數量": "聚會數量",
    "新朋友管理": "新朋友管理",
    "新朋友新增": "新朋友新增",
    "新朋友內容": "新朋友內容",
    "進階功能": "進階功能",
    "會友管理-進階功能": "會友管理 - 進階功能",
    "聚會紀錄": "聚會紀錄",
    "聚會內容": "聚會內容",
    "族群管理": "族群管理",
    "聚會查詢": "聚會查詢",
    "牧養跟進": "牧養跟進",
    "服事參與": "服事參與",
    "男女比例": "男女比例",
    "年齡分佈": "年齡分佈",
    "五重執事": "五重執事",
    "教育程度": "教育程度",
    "職業分佈": "職業分佈",
    "婚姻狀況": "婚姻狀況",
    "受洗人數": "受洗人數",
    "聚會管理": "聚會管理",
    "聚會清單": "聚會清單",
    "聚會新增": "聚會新增",
    "聚會管理-聚會清單": "聚會管理 - 聚會清單",
    "聚會排程": "聚會排程",
    "排程內容": "排程內容",
    "聚會管理-分類管理": "聚會管理 - 分類管理",
    "參數管理": "參數管理",
    "個人資料": "個人資料",
    "返回管理介面": "返回管理介面",
    "登出系統": "登出系統",
    "雙擊加入": "雙擊加入",
    "雙擊移除": "雙擊移除",
    "編輯簽到名單": "編輯簽到名單",
    "請選擇移除的項目": "請選擇移除的項目",
    "請指定協助使用App簽到本活動的會友": "請指定協助<br/>使用App簽到本活動的會友",
    "無法搜尋到您指定條件的會友": "無法搜尋到<br />您指定條件的會友",
    "可選擇X個會友": "可選擇 <b class=\"cgBase\">%s</b> 個會友",
    "已選擇X個會友": "已選擇 <b class=\"cgBase\">%s</b> 個會友",
    "標籤": "標籤",
    "尚無標籤": "尚無標籤",
    "批次標籤": "批次標籤",
    "關閉批次標籤": "關閉批次標籤",
    "已選取": "已選取",
    "全選": "全選",
    "取消全選": "取消全選",
    "雙擊移除此標籤": "雙擊移除此標籤",
    "請先選取指定會友並輸入標籤": "請先選取指定會友並輸入標籤",
    "輸入標籤後按 Enter": "輸入標籤後按 Enter",
    "搜尋範圍名字/郵件/編號": "搜尋範圍: 名字/郵件/編號",
    "請選擇標籤": "請選擇標籤",
    "即將關閉編輯推播": "即將關閉編輯推播",
    "異動項目將會清除請確認後執行": "<span class=\"text-danger\">異動項目將會清除, 請確認後執行</span>",
    "全部": "全部",
    "未分類": "未分類",
    "管理員名單": "管理員名單",
    "耗用時間": "耗用時間",
    "剩餘時間": "剩餘時間",
    "已經超時": "已經超時",
    "請輸入異常App帳號": "請輸入異常App帳號",
    "異常App帳號": "異常App帳號",
    "請輸入正確的電子郵件格式按Enter可新增一筆": "請輸入正確的電子郵件格式, 按 Enter 可新增一筆",
    "請輸入正確的電子郵件格式": "請輸入正確的電子郵件格式",
    "刪除": "刪除",
    "即將刪除指定異常帳號": "即將刪除指定異常帳號",
    "加入附件": "加入附件",
    "已經選擇X個附件": "已經選擇 <b class=\"text-danger ft-16\">%s</b> 個附件",
    "描述": "描述",
    "附件網址": "附件網址",
    "請輸入描述": "請輸入描述",
    "請輸入附件網址": "請輸入附件網址",
    "請點擊新增進行加入附件": "請點擊新增進行加入附件",
    "請先完善表單": "請先完善表單",
    "請輸入正確的附件網址": "請輸入正確的附件網址",
    "即將刪除指定附件": "即將刪除指定附件",
    "附件內容": "附件內容",
    "網址": "網址",
    "附件": "附件",
    "建立人員": "建立人員",
    "上一次編輯人": "上一次編輯人",
    "上一次編輯時間": "上一次編輯時間",
    "無法編輯": "無法編輯",
    "非目前狀態或者您不是建立人員不能進行編輯": "非目前狀態或者您不是建立人員<br/>不能進行編輯",
    "編輯": "編輯",
    "建立": "建立",
    "需要發佈App": "需要發佈App",
    "作廢": "作廢",
    "紀錄已作廢": "紀錄已作廢",
    "總教會僅有全部與管理員名單": "總教會僅有全部與管理員名單",
    "請選擇族群": "請選擇族群",
    "清除": "清除",
    "請至少選擇1個族群": "請至少選擇1個族群",
    "模擬登入中": "模擬登入中",
    "帳號名稱": "帳號名稱",
    "所在時區": "所在時區",
    "UI版本": "UI版本",
    "服務版本": "服務版本",
    "釋放快取": "釋放快取",
    "即將手動釋放快取": "即將手動釋放快取",
    "請確認後執行": "請確認後執行",
    "公告欄": "公告欄",
    "您還有X筆公告未讀取": "您還有 <b class=\"ft-14 text-danger\">%s</b> 筆公告未讀取",
    "前往公告欄": "前往公告欄",
    "系統由中華愛無界全人關懷協會提供和維護使用教學": "系統由 <a target=\"_new\" href=\"%s\">中華愛無界全人關懷協會</a> <br/> 提供和維護 / <a target=\"_new\" href=\"%s\">使用教學</a>",
    "教會邀請碼": "教會邀請碼",
    "已開啟": "已開啟",
    "未開啟": "未開啟",
    "最多只能選擇X個選項還可以選擇X個選項": "最多只能選擇 <b class=\"ft-16\">%s</b> 個選項, 還可以選擇 <b class=\"ft-16\">%s</b> 個選項",
    "已達到選項上限X個": "已達到選項上限 <b class=\"ft-16\">%s</b> 個",
    "新增自定義": "新增自定義",
    "新增電子郵件": "新增電子郵件",
    "新增自定義最多僅能設定X筆": "新增自定義最多僅能設定 <b class=\"cgBase\">%s</b> 筆",
    "寄送郵件名單最多僅能設定X筆": "寄送郵件名單最多僅能設定 <b class=\"cgBase\">%s</b> 筆",
    "常用選項": "常用選項",
    "自定義選項": "自定義選項",
    "通知方式": "通知方式",
    "活動時間點": "活動時間點",
    "%s 分鐘前": "%s 分鐘前",
    "%s 小時前": "%s 小時前",
    "X日前": "%s 日前",
    "X週前": "%s 週前",
    "請指定通知方式": "請指定通知方式",
    "請至少選擇一名收件人": "請至少選擇一名收件人",
    "請輸入郵件地址": "請輸入郵件地址",
    "郵件格式錯誤": "郵件格式錯誤",
    "YouTube": "YouTube",
    "JustForYou": "JustForYou",
    "這個選項暫時無法使用": "這個選項暫時無法使用",
    "服事": "服事",
    "單次": "單次",
    "每日": "每日",
    "每週": "每週",
    "每月": "每月",
    "每年": "每年",
    "排程預覽": "排程預覽",
    "共計X個排程": "共計 <b class=\"ft-14 text-success\">%s</b> 個排程",
    "#": "#",
    "開始時間": "開始時間",
    "報名開始時間": "報名開始時間",
    "複製此活動來新增": "複製此活動來新增",
    "即將複製活動": "即將複製活動",
    "活動複製成功": "活動複製成功",
    "代會友報名，開啟後台報名表單": "代會友報名，開啟後台報名表單",
    "開啟報到工具，於活動現場掃碼報到": "開啟報到工具，於活動現場掃碼報到",
    "顯示報名網址的二維碼": "顯示報名網址的二維碼",
    "下載報名網址的二維碼圖檔": "下載報名網址的二維碼圖檔",
    "複製報名網址到剪貼簿": "複製報名網址到剪貼簿",
    "請描述此場次的實際舉辦時間與安排": "請描述此場次的實際舉辦時間與安排",
    "此描述會顯示給報名者，請寫明實際舉辦的日期與時間": "此描述會顯示給報名者，請寫明實際舉辦的日期與時間",
    "報名結束時間": "報名結束時間",
    "請選擇報名開始時間": "請選擇報名開始時間",
    "請選擇報名結束時間": "請選擇報名結束時間",
    "報名結束時間必須大於報名開始時間": "報名結束時間必須大於報名開始時間",
    "僅能在此區間內開放報名活動實際舉辦時間請寫在活動說明中": "僅能在此區間內開放報名；活動實際舉辦時間請寫在活動說明中",
    "優惠時段必須落在報名期間內": "優惠時段必須落在報名期間內",
    "優惠時段不得重疊": "優惠時段不得重疊",
    "結束時間": "結束時間",
    "首次起始日為星期%s, 不能取消": "首次起始日為星期%s, 不能取消",
    "目前最長可定義X年週期請妥善利用資源": "目前最長可定義 %s 年週期, 請妥善利用資源",
    "如果範圍中的月份沒有第X天則會自動跳過": "如果範圍中的月份沒有第 <b class=\"text-success\">%s</b> 天, 則會自動跳過",
    "方式": "方式",
    "時長": "時長",
    "總計次數": "總計次數",
    "在第 %s 天重複": "在第 %s 天重複",
    "在最後一天重複": "在最後一天重複",
    "在第X週的X": "在第%s週的%s",
    "在最後一個X重複": "在最後一個%s重複",
    "選取希望重複的日期": "選取希望重複的日期",
    "在 %s 的第 %s 天重複": "在 %s 的第 %s 天重複",
    "在X的最後一天重複": "在 %s 的最後一天重複",
    "在X的第X週的X重複": "在 %s 的第%s週的%s重複",
    "在X的最後一個X重複": "在 %s 的最後一個%s重複",
    "選取希望在 %s 號重複的月份": "選取希望在 %s 號重複的月份",
    "請指定至少一天": "請指定至少一天",
    "請指定選項": "請指定選項",
    "請指定需要重複的日期": "請指定需要重複的日期",
    "請指定需要重複的月份": "請指定需要重複的月份",
    "請指定時長": "請指定時長",
    "授權成功": "授權成功",
    "正在準備完成": "正在準備完成",
    "驗證成功": "驗證成功",
    "請在App中進行確認": "請在App中進行確認",
    "二維碼超時": "二維碼超時",
    "重新產生二維碼": "重新產生二維碼",
    "請使用App掃描確認或切換至": "請使用App掃描確認或切換至",
    "輸入登入密碼": "輸入登入密碼",
    "請輸入登入密碼或切換至": "請輸入登入密碼或切換至",
    "App掃描確認": "App掃描確認",
    "請使用XApp掃碼登入": "請使用%sApp掃碼登入",
    "前往下載XApp": "前往下載%sApp",
    "請使用XApp掃碼進行綁定": "請使用%sApp掃碼進行綁定",
    "全部 %s 筆公告": "全部 %s 筆公告",
    "未讀取X筆公告": "未讀取 %s 筆公告",
    "請輸入標題關鍵字查詢": "請輸入標題關鍵字查詢",
    "X・X・共計X次閱讀": "%s・%s・共計 <b class=\"%s\">%s</b> 次閱讀",
    "全部 <b class=\"ft-16 %s\">%s</b> 筆公告": "全部 <b class=\"ft-16 %s\">%s</b> 筆公告",
    "篩選出X筆公告": "篩選出 <b class=\"ft-16 %s\">%s</b> 筆公告",
    "管理員": "管理員",
    "閱讀時間": "閱讀時間",
    "暫時還沒有管理員閱讀": "暫時還沒有管理員閱讀",
    "無法搜尋到您指定條件的管理員": "無法搜尋到<br />您指定條件的管理員",
    "設定教會邀請碼": "設定教會邀請碼",
    "請輸入符合規範的邀請碼": "請輸入符合規範的邀請碼",
    "邀請碼規範6個字元可用數字或英文不可使用符號": "<span class=\"ft-12 text-secondary\">邀請碼規範 <b class=\"text-danger ft-14\">6</b> 個字元, 可用數字或英文, 不可使用符號</span>",
    "圖表週期": "圖表週期",
    "掃碼成功": "掃碼成功",
    "已選擇族群": "已選擇族群",
    "雙擊標籤快速移除": "雙擊標籤快速移除",
    "清空": "清空",
    "即將清空已選擇族群": "即將清空已選擇族群",
    "啟用點名選項": "啟用點名選項",
    "點名選項可複選": "點名選項可複選",
    "請輸入點名選項名稱": "請輸入點名選項名稱",
    "新增點名選項": "新增點名選項",
    "啟用": "啟用",
    "停用": "停用",
    "已設定X個點名選項": "已設定%s個點名選項",
    "請設定點名選項": "請設定點名選項",
    "請先選擇需要加入的族群": "請先選擇需要加入的族群",
    "已經加入該族群": "已經加入該族群",
    "已經設定不跟進該會友": "已經設定不跟進該會友",
    "重新跟進": "重新跟進",
    "該會友尚未加入任何族群": "該會友尚未加入任何族群",
    "移除族群": "移除族群",
    "不跟進": "不跟進",
    "解除族群": "解除族群",
    "復原解除": "復原解除",
    "加入新族群": "加入新族群",
    "族群": "族群",
    "請選擇需要加入的新族群": "請選擇需要加入的新族群",
    "請選擇需要加入的族群": "請選擇需要加入的族群",
    "即將不跟進該名會友": "即將不跟進該名會友",
    "所有群族將全數解除及取消標註若要再次進入群族被關心請前往不跟進會友重新加入族群請確認後執行請注意儲存後才會生效": "所有群族將<span class=\"text-danger\">全數解除及取消標註</span><br />若要再次進入群族被關心<br />請前往[不跟進會友]重新加入族群, 請確認後執行<br/><span class=\"ft-14 text-warning\">請注意, 儲存後才會生效</span>",
    "不跟進會友無法選擇": "不跟進會友無法選擇",
    "最上層": "最上層",
    "總教會僅供查看資料無法新增修改": "總教會僅供查看資料, 無法新增修改",
    "族群內容": "族群內容",
    "族群新增": "族群新增",
    "族群編輯": "族群編輯",
    "請至少選擇1位會友作為託管人員": "請至少選擇<br />1位會友作為託管人員",
    "請先選擇族群成員再進行託管人員選擇": "請先選擇族群成員<br />再進行託管人員選擇",
    "族群中沒有會友請先加入會友到族群中": "族群中沒有會友<br />請先加入會友到族群中",
    "託管人員": "託管人員",
    "請至少選擇1位託管人員": "請至少選擇 <b class=\"ft-14 cgBase\">1</b> 位託管人員",
    "最多能選擇X位託管人員": ", 最多能選擇 <b class=\"ft-14 cgBase\">%s</b> 位託管人員",
    "即將關閉族群新增": "即將關閉族群新增",
    "即將關閉族群編輯": "即將關閉族群編輯",
    "即將新增族群": "即將新增族群",
    "即將更新族群內容": "即將更新族群內容",
    "請選擇族群成員": "請選擇族群成員",
    "至少需要1位族群成員": "至少需要 <b class=\"ft-20 text-danger\">1</b> 位族群成員",
    "託管人員不足最低限制": "託管人員不足最低限制",
    "至少需要1位託管人員": "至少需要 <b class=\"ft-20 text-danger\">1</b> 位託管人員",
    "託管人員超過最高限制": "託管人員超過最高限制",
    "最多只能選擇X位託管人員": "最多只能選擇 <b class=\"ft-20 text-danger\">%s</b> 位託管人員",
    "到": "到",
    "資訊": "資訊",
    "報到": "報到",
    "查看": "查看",
    "本週無聚會": "本週無聚會",
    "自評": "自評",
    "未自評": "未自評",
    "名單中沒有成員": "名單中沒有成員",
    "未留言": "未留言",
    "未報到": "未報到",
    "查看此會友資訊": "查看此會友資訊",
    "批次委派成功": "批次委派成功",
    "本次委派批次完成共計X位會友": "本次委派批次完成<br />共計 <b class=\"ft-16 text-success\">%s</b> 位會友",
    "請至少選擇1位會友進行委派": "請至少選擇<br />1位會友進行委派",
    "已標註": "已標註",
    "會友匯入成功": "會友匯入成功",
    "本次會友匯入完成共計X位會友": "本次會友匯入完成<br />共計 <b class=\"ft-16 text-success\">%s</b> 位會友",
    "新朋友": "新朋友",
    "請將匯入文件拖至此處": "請將匯入文件拖至此處",
    "或點擊上傳": "或點擊上傳",
    "只能上傳Excel文件檔案格式為xlsx文件且不超過10MB容量": "只能上傳Excel文件(檔案格式為xlsx)文件，且不超過<b class=\"text-danger opacity-75\">10MB</b>容量",
    "即將匯出全部會友": "即將匯出全部會友",
    "即將刪除全部會友": "即將刪除全部會友",
    "操作無法返回請確認後執行": "操作無法返回, 請確認後執行",
    "請輸入連結文字與網址": "請輸入連結文字與網址",
    "插入連結": "插入連結",
    "編輯連結": "編輯連結",
    "釋放連結": "釋放連結",
    "前往連結": "前往連結",
    "清空內文": "清空內文",
    "未輸入文字": "<span class=\"a1\">未輸入文字</span>",
    "合計約X個文字": "合計約 <b class=\"cgBase\">%s</b> 個文字",
    "連結網址": "連結網址",
    "連結文字": "連結文字",
    "請輸入連結網址": "請輸入連結網址",
    "請輸入連結文字": "請輸入連結文字",
    "顯示完整圖片": "顯示完整圖片",
    "文章管理": "文章管理",
    "文章內容": "文章內容",
    "文章新增": "文章新增",
    "已啟用": "已啟用",
    "發布於X．X人次瀏覽": "發布於 %s．%s 人次瀏覽",
    "請輸入文章內容": "請輸入文章內容",
    "收藏": "收藏",
    "字級": "字級",
    "前往留言": "前往留言",
    "分享文章由X授權使用": "分享文章由 <b class=\"text-black\">%s</b> 授權使用",
    "圖文": "圖文",
    "影音": "影音",
    "音樂": "音樂",
    "MP3": "MP3",
    "直播": "直播",
    "WEB": "WEB",
    "次分類為活動將無法使用直播類型": "次分類為活動, 將無法使用直播類型",
    "編輯標籤": "編輯標籤",
    "送出新增標籤": "送出新增標籤",
    "離開編輯": "離開編輯",
    "無可用標籤": "無可用標籤",
    "開啟選單": "開啟選單",
    "關閉選單": "關閉選單",
    "篩選出X個會友": "篩選出 <span class=\"cgBase\">%s</span> 個會友",
    "已選取X個會友": ", 已選取 <span class=\"cgBase\">%s</span> 個會友",
    "請選擇先篩選會友": "請選擇先篩選會友",
    "請先選擇標籤": "請先選擇標籤",
    "加入請選擇標籤與指定會友": "加入(請選擇標籤與指定會友)",
    "移除請選擇標籤與指定會友": "移除(請選擇標籤與指定會友)",
    "關鍵字": "關鍵字",
    "請輸入標籤名稱可用逗號分隔": "請輸入標籤名稱(可用逗號分隔)",
    "搜尋範圍名字/郵件/會友編號/標籤": "搜尋範圍: 名字/郵件/會友編號/標籤",
    "即將批次加入標籤": "即將批次加入標籤",
    "即將批次移除標籤": "即將批次移除標籤",
    "即將移除指定標籤": "即將移除指定標籤",
    "即將移除標籤": "即將移除標籤",
    "上傳": "上傳",
    "已選擇X張圖片最多可以上傳X張圖片": "已選擇 <b class=\"text-success ft-15\">%s</b> 張圖片, 最多可以上傳 <b class=\"text-success ft-15\">%s</b> 張圖片",
    "已經選完X張圖片": "已經選完 <b class=\"text-danger ft-15\">%s</b> 張圖片",
    "圖庫": "圖庫",
    "請先選擇圖": "請先選擇圖",
    "歷史圖": "歷史圖",
    "上傳圖": "上傳圖",
    "AI生成圖片": "AI 生成圖片",
    "生成": "生成",
    "重新生成": "重新生成",
    "換一張": "換一張",
    "使用這張": "使用這張",
    "摘要補充描述": "摘要／補充描述",
    "風格": "風格",
    "攝影": "攝影",
    "水彩": "水彩",
    "扁平插畫": "扁平插畫",
    "彩繪玻璃": "彩繪玻璃",
    "古典油畫": "古典油畫",
    "信仰主題只以象徵手法呈現不會出現人物": "信仰主題只以象徵手法呈現，不會出現人物",
    "生成中已等待X秒": "生成中，已等待 %s 秒",
    "首次生成可能需要2至3分鐘請耐心等候": "首次生成可能需要 2–3 分鐘，請耐心等候",
    "此圖為通用畫面並非依文章內容繪製建議換一張": "此圖為通用畫面，並非依文章內容繪製，建議換一張",
    "生成逾時": "生成逾時",
    "網路連線異常請稍後再試": "網路連線異常，請稍後再試",
    "人物": "人物",
    "無人物": "無人物",
    "遠景人物": "遠景人物",
    "可能出現遠景或背影人物發佈前請確認": "可能出現遠景或背影人物，發佈前請確認",
    "人物為主角": "人物為主角",
    "人物會是畫面主角聖經故事仍只畫場景發佈前請確認": "人物會是畫面主角（聖經故事仍只畫場景），發佈前請確認",
    "背影不露臉": "背影（不露臉）",
    "人物只以背影入鏡不會拍到臉": "人物只以背影入鏡，不會拍到臉",
    "剪影逆光": "剪影逆光",
    "人物是逆光的深色剪影只有輪廓沒有五官": "人物是逆光的深色剪影，只有輪廓、沒有五官",
    "手部特寫": "手部特寫",
    "畫面只有手部適合禱告聖餐與服事主題": "畫面只有手部，適合禱告、聖餐與服事主題",
    "引擎": "引擎",
    "AI繪圖服務": "AI 繪圖服務",
    "QwenImage": "Qwen-Image",
    "額外畫面要求": "額外畫面要求",
    "畫面描述": "畫面描述",
    "例如畫面中要有一座燈塔色調偏暖": "例如：畫面中要有一座燈塔、色調偏暖",
    "此引擎的人物控制屬提示詞層級效果不保證": "（此引擎的人物控制屬提示詞層級，效果不保證）",
    "寫實攝影": "寫實攝影",
    "插畫": "插畫",
    "極簡平面": "極簡平面",
    "電影感": "電影感",
    "油畫": "油畫",
    "水墨畫": "水墨畫",
    "鉛筆素描": "鉛筆素描",
    "日系動漫": "日系動漫",
    "3D 渲染": "3D 渲染",
    "復古海報": "復古海報",
    "版畫": "版畫",
    "剪紙": "剪紙",
    "圖片處理中請稍候": "圖片處理中, 請稍候",
    "清除全部": "清除全部",
    "即將取消選擇圖": "即將取消選擇圖",
    "已經編輯的內容將會重設請確認後執行": "已經編輯的內容將會重設, 請確認後執行",
    "即將清除已經設定的圖": "即將清除已經設定的圖",
    "舉報圖片": "舉報圖片",
    "重設編輯": "重設編輯",
    "上一張": "上一張",
    "沒有上一張了": "沒有上一張了",
    "下一張": "下一張",
    "沒有下一張了": "沒有下一張了",
    "取消編輯": "取消編輯",
    "編輯文字": "編輯文字",
    "文字大小": "文字大小",
    "文字顏色": "文字顏色",
    "文字位置": "文字位置",
    "上下微調": "上下微調",
    "左右微調": "左右微調",
    "填充文字": "填充文字",
    "垂直微調": "垂直微調",
    "水平微調": "水平微調",
    "請輸入填充文字": "請輸入填充文字",
    "請選擇文字大小": "請選擇文字大小",
    "請選擇文字顏色": "請選擇文字顏色",
    "請選擇文字位置": "請選擇文字位置",
    "請選擇垂直微調": "請選擇垂直微調",
    "請選擇水平微調": "請選擇水平微調",
    "放大": "放大",
    "縮小": "縮小",
    "還原縮放": "還原縮放",
    "下載": "下載",
    "逆時針旋轉": "逆時針旋轉",
    "順時針旋轉": "順時針旋轉",
    "名稱": "名稱",
    "搜尋不到指定的權限": "搜尋不到指定的權限",
    "僅總教會": "僅總教會",
    "淺色主題": "淺色主題",
    "深色主題": "深色主題",
    "已送達": "已送達",
    "送達時間%04d-%02d-%02d%02d%02d": "送達時間 %04d-%02d-%02d %02d:%02d",
    "已讀取": "已讀取",
    "未讀取": "未讀取",
    "群體推播無法編輯名單": "群體推播無法編輯名單",
    "編輯推播名單": "編輯推播名單",
    "請至少選擇<br />1位會友進行推播": "請至少選擇<br />1位會友進行推播",
    "準備中": "準備中",
    "無法推播": "無法推播",
    "用戶刪除": "用戶刪除",
    "指定": "指定",
    "全體": "全體",
    "排除機構": "排除機構",
    "選中的機構將會排除並不發送推播訊息": "選中的機構將會排除並不發送推播訊息",
    "將不排除任何機構": "將不排除任何機構",
    "編輯服事群組名單": "編輯服事群組名單",
    "即將關閉編輯服事群組": "即將關閉編輯服事群組",
    "請至少選擇1位會友參與服事群組": "請至少選擇<br />1位會友參與服事群組",
    "編輯服事名單": "編輯服事名單",
    "請選擇服事群組": "請選擇服事群組",
    "即將關閉編輯服事名單": "即將關閉編輯服事名單",
    "移除整個群組": "移除整個群組",
    "請至少選擇<br />1位會友參與服事": "請至少選擇<br />1位會友參與服事",
    "資料複製成功": "資料複製成功",
    "右鍵貼上即可以直接使用": "右鍵貼上即可以直接使用",
    "檔案下載成功": "檔案下載成功",
    "複製內容": "複製內容",
    "顯示密碼": "顯示密碼",
    "隱藏密碼": "隱藏密碼",
    "請先前往建立分類": "請先前往建立分類",
    "請先選擇指定教會": "請先選擇指定教會",
    "該教會尚未建立分類": "該教會尚未建立分類",
    "全部教會": "全部教會",
    "未選擇": "未選擇",
    "沒有可用的選項": "沒有可用的選項",
    "請先選擇所在區域": "請先選擇所在區域",
    "請先選擇類型": "請先選擇類型",
    "編輯個人標記": "編輯個人標記",
    "標記": "標記",
    "請先選擇需要移除的標記": "請先選擇需要移除的標記",
    "已經選取X個標記": "已經選取 <b class=\"cgBase\">%s</b> 個標記",
    "即將刪除指定個人標記": "即將刪除指定個人標記",
    "刪除後無法復原請確認後執行": "刪除後無法復原, 請確認後執行",
    "共計X名": "共計 %s 名",
    "由系統自動產生": "由系統自動產生",
    "上次編輯人員": "上次編輯人員",
    "內容未經過編輯": "內容未經過編輯",
    "上次編輯時間": "上次編輯時間",
    "循環資訊": "循環資訊",
    "循環代號": "循環代號",
    "提醒代號": "提醒代號",
    "最後循環開始時間": "最後循環開始時間",
    "請先清除表單錯誤": "請先清除表單錯誤",
    "您沒有建立的權限": "您沒有建立的權限",
    "您沒有更新的權限": "您沒有更新的權限",
    "總教會僅供查看資料無法更新內容": "總教會僅供查看資料, 無法更新內容",
    "聚會時間已經變動請您留意": "聚會時間已經變動, 請您留意",
    "設定的所有循環均已完成將不會再繼續生成相關單據與提醒": "設定的所有循環均已完成, 將不會再繼續生成相關單據與提醒",
    "聚會週期建立後不可修改, 以免既有的點名紀錄對應到錯誤的場次。如需調整請建立新的聚會": "聚會週期建立後不可修改, 以免既有的點名紀錄對應到錯誤的場次。如需調整請建立新的聚會",
    "即將重設內容": "即將重設內容",
    "異動內容將不會保存請確認後執行": "異動內容將不會保存, 請確認後執行",
    "即將返回列表": "即將返回列表",
    "聚會時間已經變動": "聚會時間已經變動",
    "建議您重新檢視循環與提醒設定": "建議您重新檢視循環與提醒設定",
    "所屬教會": "所屬教會",
    "請選擇所屬教會": "請選擇所屬教會",
    "請輸入關鍵字": "請輸入關鍵字",
    "同時搜尋名字/郵件/會友編號": "同時搜尋名字/郵件/會友編號",
    "開始時間起": "開始時間(起)",
    "請選擇開始時間起": "請選擇開始時間(起)",
    "開始時間迄": "開始時間(迄)",
    "請選擇開始時間迄": "請選擇開始時間(迄)",
    "結束時間起": "結束時間(起)",
    "請選擇結束時間起": "請選擇結束時間(起)",
    "結束時間迄": "結束時間(迄)",
    "請選擇結束時間迄": "請選擇結束時間(迄)",
    "建立時間起": "建立時間(起)",
    "請選擇建立時間起": "請選擇建立時間(起)",
    "建立時間迄": "建立時間(迄)",
    "請選擇建立時間迄": "請選擇建立時間(迄)",
    "≥指定時間": "(≥)指定時間",
    "≤指定時間": "(≤)指定時間",
    "新增": "新增",
    "無新增權限": "無新增權限",
    "移動至頂部": "移動至頂部",
    "移動至左方": "移動至左方",
    "移動至右方": "移動至右方",
    "搜尋": "搜尋",
    "統計": "統計",
    "多選": "多選",
    "刷新": "刷新",
    "讀取中": "讀取中",
    "匯出": "匯出",
    "無匯出權限": "無匯出權限",
    "每頁X筆資料": "每頁 <b>%s</b> 筆資料",
    "目前於第X頁共X頁全部X筆資料": "目前於 第 <b class=\"text-justforyou-base ft-16\">%s</b> 頁 共 <b class=\"text-justforyou-base ft-16\">%s</b> 頁 全部 <b class=\"text-justforyou-base ft-16\">%s</b> 筆資料",
    "列表僅供讀取": "列表僅供讀取",
    "找不到指定的資料": "找不到指定的資料",
    "主動": "主動",
    "由總教會發起的主動推播": "由總教會發起的主動推播",
    "循環": "循環",
    "已設定X筆提醒": "已設定%s筆提醒",
    "未設定提醒": "未設定提醒",
    "無查看權限": "無查看權限",
    "無編輯權限": "無編輯權限",
    "更多": "更多",
    "複製": "複製",
    "檢視": "檢視",
    "已載入X筆數據共X筆數據": "已載入 <b class=\"text-justforyou-base ft-16\">%s</b> 筆數據 共 <b class=\"text-justforyou-base ft-16\">%s</b> 筆數據",
    "載入完成": "載入完成",
    "收件人": "收件人",
    "可選X名會友": "可選 <b class=\"ft-15 text-base\">%s</b> 名會友",
    "已選X名會友": "已選 <b class=\"ft-15 text-base\">%s</b> 名會友",
    "可選X名會友篩選出X名會友": "可選 <b class=\"ft-15 text-base\">%s</b> 名會友, 篩選出 <b class=\"ft-15 text-base\">%s</b> 名會友",
    "已選X名會友篩選出X名會友": "已選 <b class=\"ft-15 text-base\">%s</b> 名會友, 篩選出 <b class=\"ft-15 text-base\">%s</b> 名會友",
    "此設定不會發送任何通知": "此設定不會發送任何通知",
    "已啟用的提醒時間點都已經過去，或服事開始時間已到，儲存後不會產生任何通知。仍要繼續嗎？": "已啟用的提醒時間點都已經過去，或服事開始時間已到，儲存後不會產生任何通知。仍要繼續嗎？",
    "已啟用的提醒時間點都已經過去，或服事開始時間已到。請調整開始時間或改選較晚的提醒。": "已啟用的提醒時間點都已經過去，或服事開始時間已到。請調整開始時間或改選較晚的提醒。",
    "已複製「%s」的內容與名單，請重新設定開始與結束時間": "已複製「%s」的內容與名單，請重新設定開始與結束時間",
    "已複製「%s」的內容與收件人，請重新設定排程時間": "已複製「%s」的內容與收件人，請重新設定排程時間",
    "已複製「%s」的全部設定與名單，請確認聚會時間與循環設定後再儲存": "已複製「%s」的全部設定與名單，請確認聚會時間與循環設定後再儲存",
    "即將退出選擇編輯": "即將退出選擇編輯",
    "合計X次循環排程": "合計 <b class=\"ft-16 text-base\">%s</b> 次循環排程",
    "每": "每",
    "日": "日",
    "週": "週",
    "個月": "個月",
    "年": "年",
    "永遠": "永遠",
    "直到": "直到",
    "重複": "重複",
    "次": "次",
    "首次起始日<br/>為星期%s不能取消": "首次起始日<br/>為星期%s不能取消",
    "在第%s天重複": "在第%s天重複",
    "在 %s 的第%s天重複": "在 %s 的第%s天重複",
    "在第X週的X重複": "在第%s週的%s重複",
    "選取希望在%s號重複的月份": "選取希望在%s號重複的月份",
    "請選擇重複結束時間": "請選擇重複結束時間",
    "請選擇條件": "請選擇條件",
    "請選取希望重複的日期": "請選取希望重複的日期",
    "請選取希望重複的月份": "請選取希望重複的月份",
    "新增自定義選項": "新增自定義選項",
    "系統內建提醒無法取消": "系統內建提醒無法取消",
    "已選X個選項": "已選%s個選項",
    "已設定X個電子郵件": "已設定%s個電子郵件",
    "自定義選項最多僅能設定X筆": "自定義選項最多僅能設定 %s 筆",
    "郵件名單最多僅能設定X筆": "郵件名單最多僅能設定 %s 筆",
    "請輸入正確的電子郵件": "請輸入正確的電子郵件",
    "標記為*為必填欄位": "標記為 <b class=\"cgRed\">*</b> 為必填欄位",
    "即將清除表單": "即將清除表單",
    "已經填寫的資料將會清除請確認後執行": "<span class=\"text-danger\">已經填寫的資料將會清除, 請確認後執行</span>",
    "請選擇指定教會": "請選擇指定教會",
    "請謹慎使用指定教會功能": "請謹慎使用指定教會功能",
    "搜尋條件": "搜尋條件",
    "自行維護": "自行維護",
    "委託管理": "委託管理",
    "前往查看": "前往查看",
    "前往編輯": "前往編輯",
    "轉入牧養會友": "轉入牧養會友",
    "標記為待轉入": "標記為待轉入",
    "標記為不轉入": "標記為不轉入",
    "未授權編輯": "未授權編輯",
    "轉交愛無界團隊": "轉交愛無界團隊",
    "標示已付款": "標示已付款",
    "整合文章無法複製": "整合文章無法複製",
    "留言內容": "留言內容",
    "該群組下仍有X個會友無法刪除": "該群組下仍有 %s 個會友, 無法刪除",
    "該分類下仍有X篇文章無法刪除": "該分類下仍有 %s 篇文章, 無法刪除",
    "該分類下仍有X場活動無法刪除": "該分類下仍有 %s 場活動, 無法刪除",
    "該分類下仍有X場直播無法刪除": "該分類下仍有 %s 場直播, 無法刪除",
    "該分類下仍有X個聚會無法刪除": "該分類下仍有 %s 個聚會, 無法刪除",
    "刪除前請先停用": "刪除前請先停用",
    "模擬登入": "模擬登入",
    "重建模擬": "重建模擬",
    "選取": "選取",
    "最後編輯時間": "最後編輯時間",
    "最後編輯人員": "最後編輯人員",
    "最後存取時間": "最後存取時間",
    "每頁X項資料": "每頁 %s 項資料",
    "目前顯示第X頁共X頁全部共X項資料": "目前顯示 第 <b class=\"cgBase\">%s</b> 頁 共 <b class=\"cgBase\">%s</b> 頁 全部共 <b class=\"cgBase\">%s</b> 項資料",
    "最前頁": "最前頁",
    "上一頁": "上一頁",
    "下一頁": "下一頁",
    "最後頁": "最後頁",
    "資料讀取中": "資料讀取中",
    "抱歉😔": "抱歉...😔",
    "沒有找到指定的資料": "沒有找到指定的資料",
    "全部共0項資料": "全部共 <b class=\"cgBase\">0</b> 項資料",
    "正在讀取請稍候": "正在讀取...請稍候",
    "目前暫時沒有可用排序的項目": "目前暫時<br />沒有可用排序的項目",
    "拖曳進行排序": "拖曳進行排序",
    "系統由中華愛無界全人關懷協會提供和維護/使用教學": "系統由 <a target=\"_new\" href=\"%s\">中華愛無界全人關懷協會</a> <br/> 提供和維護 / <a target=\"_new\" href=\"%s\">使用教學</a>",
    "選項可複選": "選項可複選",
    "請輸入選項名稱": "請輸入選項名稱",
    "請至少建立1筆選項": "請至少建立1筆選項",
    "回到頂端": "回到頂端",
    "往左翻動": "往左翻動",
    "往右翻動": "往右翻動",
    "翻至編輯": "翻至編輯",
    "第 <b class=\"ft-20 text-danger\">%s</b> 場": "第 <b class=\"ft-20 text-danger\">%s</b> 場",
    "新增場次": "新增場次",
    "請依照升序方式編輯或刪除避免日期設定錯誤": "請依照升序方式編輯或刪除, 避免日期設定錯誤",
    "場次名稱": "場次名稱",
    "第 <b class=\"m-l-5 m-r-5 ft-28\">%s</b> 場": "第 <b class=\"m-l-5 m-r-5 ft-28\">%s</b> 場",
    "X至X": "%s 至 %s",
    "請輸入課程名稱": "請輸入課程名稱",
    "即將刪除場次": "即將刪除場次",
    "上移": "上移",
    "下移": "下移",
    "請輸入場次名稱": "請輸入場次名稱",
    "請輸入X": "請輸入%s",
    "是": "是",
    "否": "否",
    "請輸入X的描述": "請輸入%s的描述",
    "請選擇X的描述": "請選擇%s的描述",
    "請選擇X": "請選擇%s",
    "請輸入姓名": "請輸入姓名",
    "第X位報名人員": "第 <b class=\"ft-16 text-success\">%s</b> 位報名人員",
    "必填": "必填",
    "電子郵件格式錯誤": "電子郵件格式錯誤",
    "請至少選擇一個選項": "請至少選擇一個選項",
    "請依照順序編輯": "請依照順序編輯",
    "新增報名優惠": "新增報名優惠",
    "編輯報名優惠": "編輯報名優惠",
    "請依照升序方式編輯或刪除避免日期與優惠價格設定錯誤": "請依照升序方式編輯或刪除, 避免日期與優惠價格設定錯誤",
    "新增團報": "新增團報",
    "最多僅能建立X筆報名優惠": "最多僅能建立 <b class=\"cgBase\">%s</b> 筆報名優惠",
    "優惠價格已經達到最高值無法再繼續設定優惠價格": "優惠價格已經達到最高值, 無法再繼續設定優惠價格",
    "若關閉外部報名僅能用App報名並且無法使用團體報名": "若關閉外部報名, 僅能用App報名並且無法使用團體報名",
    "開啟": "開啟",
    "需收費": "需收費",
    "免費": "免費",
    "需限制": "需限制",
    "不限制": "不限制",
    "外部報名": "外部報名",
    "人數上限": "人數上限",
    "人數": "人數",
    "費用": "費用",
    "金額": "金額",
    "掃碼報到": "掃碼報到",
    "報名方式": "報名方式",
    "個人報名": "個人報名",
    "團體報名": "團體報名",
    "團體最少報名人數": "團體最少報名人數",
    "團體最多報名人數": "團體最多報名人數",
    "優惠內容": "優惠內容",
    "報名優惠": "報名優惠",
    "優惠價格": "優惠價格",
    "描述內容": "描述內容",
    "可以直接編輯": "可以直接編輯",
    "線上支付": "線上支付",
    "未付款": "未付款",
    "已付款": "已付款",
    "包含往前日期": "<span class=\"text-danger\">(包含往前日期)</span>",
    "溫馨提示": "溫馨提示",
    "人數上限未達團體報名最低限制X人無法使用團體報名僅能使用個人報名": "人數上限未達團體報名最低限制 <b class=\"text-danger ft-16\">%s</b> 人, 無法使用團體報名, 僅能使用個人報名",
    "備註": "備註",
    "已經設定活動免費無法啟用線上支付功能": "已經設定活動免費, 無法啟用線上支付功能",
    "貴教會未開啟線上奉獻功能無法啟用線上支付功能": "貴教會未開啟線上奉獻功能, 無法啟用線上支付功能",
    "當報名費用低於30或超過20000時將無法使用超商代碼繳費方式支付": "當報名費用低於 <b class=\"text-success ft-16\">30</b> 或 超過 <b class=\"text-success ft-16\">20,000</b> 時, 將無法使用 <b class=\"text-success\">超商代碼繳費</b> 方式支付",
    "當報名費用低於20或超過40000時將無法使用超商條碼繳費方式支付": "當報名費用低於 <b class=\"text-success ft-16\">20</b> 或 超過 <b class=\"text-success ft-16\">40,000</b> 時, 將無法使用 <b class=\"text-success\">超商條碼繳費</b> 方式支付",
    "當報名費用超過49999時將無法使用WebATMATM轉帳方式支付": "當報名費用超過 <b class=\"text-success ft-16\">49,999</b> 時, 將無法使用 <b class=\"text-success\">WebATM</b>, <b class=\"text-success\">ATM轉帳</b> 方式支付",
    "WebATMATM轉帳支付方式僅支援台灣銀行與華南銀行之銀行戶頭": "<b class=\"text-success\">WebATM</b>, <b class=\"text-success\">ATM轉帳</b> 支付方式, 僅支援 <b class=\"text-success\">台灣銀行</b> 與 <b class=\"text-success\">華南銀行</b> 之銀行戶頭",
    "以上單位均為新臺幣": "以上單位均為 <b class=\"text-success\">新臺幣</b>",
    "請輸入人數": "請輸入人數",
    "請輸入金額": "請輸入金額",
    "請輸入團體最少報名人數": "請輸入團體最少報名人數",
    "請輸入團體最多報名人數": "請輸入團體最多報名人數",
    "請輸入優惠價格": "請輸入優惠價格",
    "請輸入描述內容": "請輸入描述內容",
    "即將刪除優惠價格": "即將刪除優惠價格",
    "即將清空優惠價格設定": "即將清空優惠價格設定",
    "您已經有設定優惠價格請確認後執行": "您已經有設定優惠價格, 請確認後執行",
    "變更場次": "變更場次",
    "第 <b class=\"ft-22\">%s</b> 場": "第 <b class=\"ft-22\">%s</b> 場",
    "即將變更場次": "即將變更場次",
    "請至少加入一筆報名優惠": "請至少加入一筆報名優惠",
    "請輸入開始時間": "請輸入開始時間",
    "請輸入結束時間": "請輸入結束時間",
    "請至少選擇一種報名方式": "請至少選擇一種報名方式",
    "優惠價格設定異常": "優惠價格設定異常",
    "請輸入最少報名人數": "請輸入最少報名人數",
    "低於最少報名人數限制": "低於最少報名人數限制",
    "請輸入最多報名人數": "請輸入最多報名人數",
    "高於報名限制人數": "高於報名限制人數",
    "欄位設定": "欄位設定",
    "新增欄位": "新增欄位",
    "新增選項": "新增選項",
    "系統條件無法移除": "系統條件無法移除",
    "請至少新增一筆選項": "請至少新增一筆選項",
    "附加輸入框": "附加輸入框",
    "文字區塊": "文字區塊",
    "文字": "文字",
    "是否": "是否",
    "複選": "複選",
    "單選": "單選",
    "日期": "日期",
    "姓名": "姓名",
    "選項值": "選項值",
    "顯示": "顯示",
    "請輸入顯示名稱": "請輸入顯示名稱",
    "請輸入選項值": "請輸入選項值",
    "即將刪除欄位": "即將刪除欄位",
    "請至少選擇一個顯示欄位": "請至少選擇一個顯示欄位",
    "請輸入名稱": "請輸入名稱",
    "推播至活動建立者": "推播至活動建立者",
    "遞交報名後提醒的傳達方式": "遞交報名後提醒的傳達方式",
    "推播通知": "推播通知",
    "需要早於直撥開始時間": "需要早於直撥開始時間",
    "需要早於活動開始時間": "需要早於活動開始時間",
    "將自動同步直撥標題": "將自動同步直撥標題",
    "將自動同步文章標題": "將自動同步文章標題",
    "複製直播描述": "複製直播描述",
    "前往設定分享描述": "前往設定分享描述",
    "整合": "整合",
    "種類": "種類",
    "主分類": "主分類",
    "次分類": "次分類",
    "轉發分享": "轉發分享",
    "內容": "內容",
    "請選擇主分類": "請選擇主分類",
    "請選擇次分類": "請選擇次分類",
    "請選擇上架時間": "請選擇上架時間",
    "請選擇下架時間": "請選擇下架時間",
    "請選擇轉發分享": "請選擇轉發分享",
    "請輸入內容": "請輸入內容",
    "上架時間需要小於直播開始時間": "上架時間需要小於直播開始時間",
    "下架時間必須大於上架時間": "下架時間必須大於上架時間",
    "請選擇種類": "請選擇種類",
    "領袖的好幫手會友的好工具": "領袖的好幫手, 會友的好工具",
    "一個專屬教會的APP是教會的媒體與資訊發佈工具": "一個專屬教會的APP, 是教會的媒體與資訊發佈工具",
    "教會訊息活動不漏接隨時隨地跟著讀經禱告": "教會訊息、活動不漏接, 隨時隨地跟著讀經、禱告",
    "Apple用戶端": "Apple用戶端",
    "Android用戶端": "Android用戶端",
    "系統安全性增強請求": "系統安全性增強請求",
    "請使用App上的掃描功能進行管理員綁定": "請使用App上的掃描功能, 進行管理員綁定",
    "如未綁定將暫時無法使用管理功能": "如未綁定將暫時無法使用管理功能",
    "尚未完成App綁定": "尚未完成App綁定",
    "綁定後開啟App掃碼就能登入更快也更安全": "綁定後, 開啟App掃碼就能登入, 更快也更安全",
    "免輸入帳號密碼掃碼即可登入": "免輸入帳號密碼, 掃碼即可登入",
    "未綁定不影響現有的帳號密碼登入": "未綁定不影響現有的帳號密碼登入",
    "隨時可從右上角頭像選單的個人資料完成綁定": "隨時可從右上角頭像選單的「個人資料」完成綁定",
    "不再顯示此提示": "不再顯示此提示",
    "綁定後可使用App掃碼登入未綁定不影響帳號密碼登入": "綁定後可使用App掃碼登入, 未綁定不影響帳號密碼登入",
    "您的帳號已完成App綁定可使用App掃碼登入": "您的帳號已完成App綁定, 可使用App掃碼登入",
    "綁定App登入": "綁定App登入",
    "綁定狀態": "綁定狀態",
    "已綁定": "已綁定",
    "尚未綁定": "尚未綁定",
    "App綁定": "App綁定",
    "綁定會友": "綁定會友",
    "App帳號": "App帳號",
    "解除綁定": "解除綁定",
    "解除後可重新綁定其他App帳號": "解除後可重新綁定其他App帳號",
    "確定解除App綁定": "確定解除App綁定？",
    "解除後將無法再用目前的App帳號掃碼登入之後可以重新綁定其他App帳號": "解除後將無法再用目前的App帳號掃碼登入, 之後可以重新綁定其他App帳號 (不影響帳號密碼登入)",
    "已解除App綁定": "已解除App綁定",
    "前往綁定": "前往綁定",
    "稍後再說": "稍後再說",
    "APP管理系統": "APP管理系統",
    "掃碼登入": "掃碼登入",
    "帳密登入": "帳密登入",
    "忘記密碼": "忘記密碼",
    "登入帳號": "登入帳號",
    "驗證碼": "驗證碼",
    "請輸入登入帳號": "請輸入登入帳號",
    "請輸入圖形中的文字": "請輸入圖形中的文字",
    "暫時無法使用": "暫時無法使用",
    "請稍後再試或請聯絡管理人員": "請稍後再試或請聯絡管理人員",
    "驗證碼應為6個字元": "驗證碼應為6個字元",
    "驗證碼錯誤": "驗證碼錯誤",
    "重設登入密碼": "重設登入密碼",
    "返回登入": "返回登入",
    "本次重設密碼令牌將在X秒後失效": "本次重設密碼令牌將在 <b class=\"ft-14 text-danger\">%s</b> 秒後失效",
    "本次重設密碼令牌已經失效": "本次重設密碼令牌已經失效",
    "新密碼": "新密碼",
    "確認新密碼": "確認新密碼",
    "請輸入新密碼": "請輸入新密碼",
    "請再輸入一次新密碼進行確認": "請再輸入一次新密碼進行確認",
    "密碼重設成功": "密碼重設成功",
    "請使用您設定的新密碼登入": "請使用您設定的新密碼登入",
    "是否確定放棄重設密碼": "是否確定放棄重設密碼",
    "確認後將返回登入頁面": "確認後將返回登入頁面",
    "新密碼強度不足": "新密碼強度不足",
    "請再輸入新密碼進行確認": "請再輸入新密碼進行確認",
    "新密碼確認失敗": "新密碼確認失敗",
    "兩次密碼輸入不一致": "兩次密碼輸入不一致",
    "重設密碼令牌已失效": "重設密碼令牌已失效",
    "請重新進行忘記密碼程序": "請重新進行忘記密碼程序",
    "確認郵件驗證碼": "確認郵件驗證碼",
    "請輸入電子郵件中的6位數字驗證碼": "請輸入電子郵件中的 6 位數字驗證碼",
    "驗證碼空白": "驗證碼空白",
    "請輸入您的驗證碼": "請輸入您的驗證碼",
    "驗證碼長度異常": "驗證碼長度異常",
    "驗證碼長度應為6個數字": "驗證碼長度應為 <b class=\"ft-18 text-danger\">6</b> 個數字",
    "請確認您的驗證碼": "請確認您的驗證碼",
    "請輸入管理員帳號": "請輸入管理員帳號",
    "請輸入管理員電子郵件": "請輸入管理員電子郵件",
    "帳號長度不符合規則": "帳號長度不符合規則",
    "至少需要X個字元": "至少需要 <b class=\"ft-20 text-danger\">%s</b> 個字元",
    "找不到指定的管理員": "找不到指定的管理員",
    "未讀": "未讀",
    "暫時沒有任何公告": "暫時沒有任何公告",
    "找不到指定的公告": "找不到指定的公告",
    "X・共計X次閱讀": "%s・共計 <b class=\"%s\">%s</b> 次閱讀",
    "未置頂": "未置頂",
    "新增公吿": "新增公吿",
    "即將啟用公告": "即將啟用公告",
    "即將停用公告": "即將停用公告",
    "安全性二級驗證": "安全性二級驗證",
    "即將刪除公告請確認後執行": "<span class=\"cgRed\">即將刪除公告, 請確認後執行</span>",
    "請輸入您目前的登入密碼": "請輸入您目前的登入密碼",
    "請選擇是否置頂": "請選擇是否置頂",
    "即將新增公吿": "即將新增公吿",
    "閱讀": "閱讀",
    "搜尋範圍名字/郵件/會友編號": "搜尋範圍: 名字/郵件/會友編號",
    "即將更新公告內容": "即將更新公告內容",
    "最後更新時間": "最後更新時間",
    "預設區間": "預設區間",
    "正在計算統計數據": "正在計算統計數據...",
    "新增管理員": "新增管理員",
    "未輸入": "未輸入",
    "即將啟用管理員": "即將啟用管理員",
    "即將停用管理員": "即將停用管理員",
    "即將刪除管理員請確認後執行": "<span class=\"cgRed\">即將刪除管理員, 請確認後執行</span>",
    "權限": "權限",
    "設置密碼": "設置密碼",
    "聯絡電話": "聯絡電話",
    "請輸入關鍵字或權限代號進行權限名稱搜尋": "請輸入關鍵字或權限代號, 進行權限名稱搜尋",
    "即將新增管理員": "即將新增管理員",
    "帳號已經使用": "帳號已經使用",
    "請更換一個帳號": "請更換一個帳號",
    "登入密碼強度不足": "登入密碼強度不足",
    "請再輸入登入密碼進行確認": "請再輸入登入密碼進行確認",
    "密碼確認失敗": "密碼確認失敗",
    "如果不需要變更密碼不用填寫": "如果不需要變更密碼, 不用填寫",
    "系統帳號不得變更權限": "系統帳號, 不得變更權限",
    "請注意這名管理員已經停用": "請注意, 這名管理員已經停用",
    "即將更新管理員內容": "即將更新管理員內容",
    "您即將移除您編輯管理員權限的功能移除後你將無法編輯管理員請確認後執行": "<span class=\"text-danger ft18\">您即將移除您編輯管理員權限的功能<br />移除後你將無法編輯管理員, 請確認後執行</span>",
    "請輸入當前密碼": "請輸入當前密碼",
    "當前密碼錯誤": "當前密碼錯誤",
    "即將返回首頁": "即將返回首頁",
    "您已經自行移除管理員管理員權限": "您已經自行移除管理員管理員權限",
    "檔案匯出_教會管理": "檔案匯出_教會管理",
    "新增教會": "新增教會",
    "建立日期起": "建立日期(起)",
    "建立日期迄": "建立日期(迄)",
    "主圖": "主圖",
    "編號": "編號",
    "心靈捕手狀態": "心靈捕手狀態",
    "每日靈糧狀態": "每日靈糧狀態",
    "請選擇建立日期起": "請選擇建立日期(起)",
    "請選擇建立日期迄": "請選擇建立日期(迄)",
    "請輸入編號": "請輸入編號",
    "請選擇心靈捕手狀態": "請選擇心靈捕手狀態",
    "請選擇每日靈糧狀態": "請選擇每日靈糧狀態",
    "即將啟用教會": "即將啟用教會",
    "即將停用教會": "即將停用教會",
    "即將進行教會匯出請確認後執行": "<span class=\"cgRed\">即將進行教會匯出, 請確認後執行</span>",
    "聯絡人": "聯絡人",
    "奉獻": "奉獻",
    "模組": "模組",
    "所在地區": "所在地區",
    "所在城市": "所在城市",
    "地址": "地址",
    "機構": "機構",
    "控制項": "控制項",
    "我的教會標題名稱": "我的教會標題名稱",
    "尺寸為XxX像素": "(尺寸為 %sx%s 像素)",
    "標題圖": "標題圖",
    "系統模式": "系統模式",
    "每日靈糧標題名稱": "每日靈糧標題名稱",
    "心靈捕手標題名稱": "心靈捕手標題名稱",
    "查詢長度": "查詢長度",
    "奉獻方式": "奉獻方式",
    "藍新金流MerchantID": "藍新金流Merchant ID",
    "藍新金流HashKEY": "藍新金流Hash KEY",
    "藍新金流HashIV": "藍新金流Hash IV",
    "奉獻連結文字": "奉獻連結文字",
    "奉獻連結": "奉獻連結",
    "奉獻描述內容": "奉獻描述內容",
    "其他設定": "其他設定",
    "App首頁最新消息筆數": "App首頁最新消息筆數",
    "查詢區間": "查詢區間",
    "邀請碼模式": "邀請碼模式",
    "請選擇所在地區": "請選擇所在地區",
    "請選擇所在城市": "請選擇所在城市",
    "請輸入地址": "請輸入地址",
    "請選擇時區": "請選擇時區",
    "請選擇機構": "請選擇機構",
    "請輸入我的教會標題名稱": "請輸入我的教會標題名稱",
    "請輸入每日靈糧標題名稱": "請輸入每日靈糧標題名稱",
    "請輸入心靈捕手標題名稱": "請輸入心靈捕手標題名稱",
    "請選擇查詢長度": "請選擇查詢長度",
    "請輸入藍新金流MerchantID": "請輸入藍新金流Merchant ID",
    "請輸入藍新金流HashKEY": "請輸入藍新金流Hash KEY",
    "請輸入藍新金流HashIV": "請輸入藍新金流Hash IV",
    "請輸入奉獻連結文字": "請輸入奉獻連結文字",
    "請輸入奉獻連結": "請輸入奉獻連結",
    "請輸入奉獻描述內容": "請輸入奉獻描述內容",
    "請選擇App首頁最新消息筆數": "請選擇App首頁最新消息筆數",
    "請選擇查詢區間": "請選擇查詢區間",
    "即將新增教會": "即將新增教會",
    "異常發生": "異常發生",
    "無法停用目前登入的教會": "無法停用目前登入的教會",
    "請選擇所在區域": "請選擇所在區域",
    "請選擇所在時區": "請選擇所在時區",
    "請選擇心靈捕手系統模式": "請選擇心靈捕手系統模式",
    "請選擇每日靈糧系統模式": "請選擇每日靈糧系統模式",
    "編號已經存在": "編號已經存在",
    "請選擇邀請碼模式": "請選擇邀請碼模式",
    "請輸入主要聯絡人姓名": "請輸入主要聯絡人姓名",
    "請輸入主要聯絡人聯絡電話": "請輸入主要聯絡人聯絡電話",
    "請輸入主要聯絡人電子郵件": "請輸入主要聯絡人電子郵件",
    "主要聯絡人電子郵件格式錯誤": "主要聯絡人電子郵件格式錯誤",
    "次要聯絡人電子郵件格式錯誤": "次要聯絡人電子郵件格式錯誤",
    "請選擇奉獻系統模式": "請選擇奉獻系統模式",
    "請注意這間教會已經停用": "請注意, 這間教會已經停用",
    "簡介標題": "簡介標題",
    "簡介內容": "簡介內容",
    "請輸入簡介標題": "請輸入簡介標題",
    "請輸入簡介內容": "請輸入簡介內容",
    "即將清除教會邀請碼": "即將清除教會邀請碼",
    "清除後儲存將無法使用教會邀請碼功能請確認後執行": "<span class=\"text-danger\">清除後儲存, 將無法使用教會邀請碼功能<br />請確認後執行</span>",
    "即將更新教會內容": "即將更新教會內容",
    "請先選取指定會友": "請先選取指定會友",
    "附加標籤到指定會友": "附加標籤到指定會友",
    "清除並附加標籤到指定會友": "清除並附加標籤到指定會友",
    "刪除指定會友的標籤": "刪除指定會友的標籤",
    "重設已輸入標籤值": "重設已輸入標籤值",
    "檔案匯出_會友管理": "檔案匯出_會友管理",
    "新增會友": "新增會友",
    "開啟編輯標籤": "開啟編輯標籤",
    "關閉編輯標籤": "關閉編輯標籤",
    "委身編號": "委身編號",
    "未填寫": "未填寫",
    "請輸入標籤可用逗號分隔連續輸入並按enter輸入": "請輸入標籤,可用逗號分隔連續輸入並按enter輸入",
    "即將啟用會友": "即將啟用會友",
    "即將停用會友": "即將停用會友",
    "即將對指定的會友加入標籤": "即將對指定的會友加入標籤",
    "即將對指定的會友取代標籤": "即將對指定的會友取代標籤",
    "即將對指定的會友移除標籤": "即將對指定的會友移除標籤",
    "即將進行會友匯出請確認後執行": "<span class=\"cgRed\">即將進行會友匯出, 請確認後執行</span>",
    "即將進行全部會友刪除請確認後執行": "<span class=\"cgRed\">即將進行全部會友刪除, 請確認後執行</span>",
    "請注意這名會友已經停用": "請注意, 這名會友已經停用",
    "統計資訊": "統計資訊",
    "文章回覆": "文章回覆",
    "所屬教會名稱": "所屬教會名稱",
    "所屬教會ID": "所屬教會ID",
    "稱謂": "稱謂",
    "生日": "生日",
    "聯絡地址": "聯絡地址",
    "職業": "職業",
    "受洗時間": "受洗時間",
    "刪除時間": "刪除時間",
    "未輸入稱謂": "未輸入稱謂",
    "未輸入生日": "未輸入生日",
    "未輸入聯絡電話": "未輸入聯絡電話",
    "未輸入所在地區": "未輸入所在地區",
    "未輸入所在城市": "未輸入所在城市",
    "未輸入聯絡地址": "未輸入聯絡地址",
    "未輸入職業": "未輸入職業",
    "未輸入受洗時間": "未輸入受洗時間",
    "請輸入委身編號": "請輸入委身編號",
    "即將更新會友內容": "即將更新會友內容",
    "新增循環": "新增循環",
    "週期": "週期",
    "即將啟用循環": "即將啟用循環",
    "即將停用循環": "即將停用循環",
    "建立後類型與目標無法修改請確認": "建立後類型與目標無法修改, 請確認",
    "點擊查看說明": "點擊查看說明",
    "部分文章無法設定循環": "部分文章無法設定循環",
    "排程時間": "排程時間",
    "項目": "項目",
    "請選擇類型": "請選擇類型",
    "未填寫標題": "未填寫標題",
    "未選擇上架時間": "未選擇上架時間",
    "未選擇排程時間": "未選擇排程時間",
    "未選擇開始時間": "未選擇開始時間",
    "未選擇下架時間": "未選擇下架時間",
    "未選擇結束時間": "未選擇結束時間",
    "請選擇項目": "請選擇項目",
    "即將新增循環": "即將新增循環",
    "請注意這筆循環已經停用": "請注意, 這筆循環已經停用",
    "建立後類型與目標無法修改": "建立後類型與目標無法修改",
    "歷程紀錄": "歷程紀錄",
    "即將更新循環內容": "即將更新循環內容",
    "新增分類": "新增分類",
    "文章數量": "文章數量",
    "排序": "排序",
    "請選擇教會": "請選擇教會",
    "即將啟用分類": "即將啟用分類",
    "即將停用分類": "即將停用分類",
    "即將刪除分類請確認後執行": "<span class=\"cgRed\">即將刪除分類, 請確認後執行</span>",
    "僅能指定自行維護心靈捕手的教會": "僅能指定自行維護心靈捕手的教會",
    "即將新增分類": "即將新增分類",
    "請選擇封面圖": "請選擇封面圖",
    "請指定教會": "請指定教會",
    "請注意這個分類已經停用": "請注意, 這個分類已經停用",
    "即將更新分類內容": "即將更新分類內容",
    "文章整合": "文章整合",
    "查看留言紀錄": "查看留言紀錄",
    "查看推播紀錄": "查看推播紀錄",
    "新增文章": "新增文章",
    "分享連結": "分享連結",
    "請選擇置頂": "請選擇置頂",
    "請選擇分類": "請選擇分類",
    "我的教會x心靈捕手": "我的教會x心靈捕手",
    "請貼上您的分享連結": "<span class=\"text-success\">請貼上您的分享連結</span>",
    "請輸入分享連結": "請輸入分享連結",
    "即將文章置頂": "即將文章置頂",
    "即將文章取消置頂": "即將文章取消置頂",
    "即將啟用文章": "即將啟用文章",
    "即將停用文章": "即將停用文章",
    "即將刪除文章請確認後執行": "<span class=\"cgRed\">即將刪除文章, 請確認後執行</span>",
    "活動": "活動",
    "類型為直播無法使用活動次分類": "類型為直播, 無法使用活動次分類",
    "僅能指定自行維護每日靈糧的教會": "僅能指定自行維護每日靈糧的教會",
    "循環方式": "循環方式",
    "聚會週期": "聚會週期",
    "循環日": "循環日",
    "時間": "時間",
    "文章圖片": "文章圖片",
    "分享內文": "分享內文",
    "請選擇循環方式": "請選擇循環方式",
    "請選擇循環日": "請選擇循環日",
    "請選擇日期": "請選擇日期",
    "請選擇時間": "請選擇時間",
    "請輸入分享內文": "請輸入分享內文",
    "即將清除所有文章圖片": "即將清除所有文章圖片",
    "即將新增文章": "即將新增文章",
    "即將複製文章": "即將複製文章",
    "請輸入分享描述": "請輸入分享描述",
    "此文章無法複製": "此文章無法複製",
    "已經啟用整合功能": "已經啟用整合功能",
    "重計留言數量": "重計留言數量",
    "請先選擇需要刪除的留言": "請先選擇需要刪除的留言",
    "即將重新計算文章留言數量": "即將重新計算文章留言數量",
    "即將刪除文章留言": "即將刪除文章留言",
    "請注意這篇文章已經停用": "請注意, 這篇文章已經停用",
    "已啟用直播文章整合無法編輯": "已啟用直播文章整合, 無法編輯",
    "已啟用活動文章整合無法編輯": "已啟用活動文章整合, 無法編輯",
    "心靈捕手外部文章整合無法編輯": "心靈捕手外部文章整合, 無法編輯",
    "前往修改": "前往修改",
    "觀看次數": "觀看次數",
    "所屬教會編號": "所屬教會編號",
    "即將更新文章內容": "即將更新文章內容",
    "此分類下找不到圖片": "此分類下找不到圖片",
    "請先選擇需要處理的圖片": "請先選擇需要處理的圖片",
    "全部X張圖片": "全部 <b class=\"ft-16 cgBase\">%s</b> 張圖片",
    "即將重新整理": "即將重新整理",
    "已選擇的項目將會重設請確認後執行": "已選擇的項目將會重設, 請確認後執行",
    "即將核准指定的圖片": "即將核准指定的圖片",
    "即將拒絕指定的圖片": "即將拒絕指定的圖片",
    "核實檢舉": "核實檢舉",
    "撤銷檢舉": "撤銷檢舉",
    "即將核實檢舉指定的圖片": "即將核實檢舉指定的圖片",
    "即將撤銷檢舉指定的圖片": "即將撤銷檢舉指定的圖片",
    "請選擇會友進行推播通知": "請選擇會友進行推播通知",
    "最多只能選擇X位會友進行推播通知": "最多只能選擇%s位會友進行推播通知",
    "請選擇至少X位會友進行推播通知": "請選擇至少%s位會友進行推播通知",
    "搜尋不到指定的推播通知會友": "搜尋不到指定的推播通知會友",
    "名單": "名單",
    "類型於建立之後不能變更": "類型於建立之後不能變更",
    "請選擇排程時間": "請選擇排程時間",
    "簡述": "簡述",
    "請輸入簡述": "請輸入簡述",
    "推播目前正在排程中": "推播目前正在排程中",
    "目前推播正在進行中無法修改進度X": "目前推播正在進行中無法修改, 進度 %s",
    "推播已經全部完成無法修改": "推播已經全部完成無法修改",
    "即將儲存內容": "即將儲存內容",
    "編輯名單": "編輯名單",
    "預覽排程": "預覽排程",
    "請選擇排除機構": "請選擇排除機構",
    "不能排除所有機構": "不能排除所有機構",
    "排程時間必須大於現在時間": "排程時間必須大於現在時間",
    "請至少選擇1位會友進行推播": "請至少選擇1位會友進行推播",
    "讀取": "讀取",
    "讀取時間": "讀取時間",
    "送達狀態": "送達狀態",
    "送達時間": "送達時間",
    "開啟時間": "開啟時間",
    "發送分析": "發送分析",
    "發送清單": "發送清單",
    "請選擇讀取": "請選擇讀取",
    "執行時間": "執行時間",
    "生成時間": "生成時間",
    "識別ID": "識別ID",
    "支援廠商": "支援廠商",
    "APNS": "APNS",
    "FCM": "FCM",
    "未對應": "未對應",
    "已對應": "已對應",
    "推播類型": "推播類型",
    "請選擇推播類型": "請選擇推播類型",
    "即將更新內容": "即將更新內容",
    "對象": "對象",
    "指定推播": "指定推播",
    "全體推播": "全體推播",
    "推播數量": "推播數量",
    "進度X": "<br/>進度 %s",
    "排程中": "排程中",
    "發送中": "發送中",
    "已完成": "已完成",
    "請選擇對象": "請選擇對象",
    "排程時間起": "排程時間(起)",
    "請選擇排程時間起": "請選擇排程時間(起)",
    "排程時間迄": "排程時間(迄)",
    "請選擇排程時間迄": "請選擇排程時間(迄)",
    "即將刪除推播通知請確認後執行": "<span class=\"cgRed\">即將刪除推播通知, 請確認後執行</span>",
    "排程日期起": "排程日期(起)",
    "排程日期迄": "排程日期(迄)",
    "數量": "數量",
    "進度": "進度",
    "請選擇排程日期起": "請選擇排程日期(起)",
    "請選擇排程日期迄": "請選擇排程日期(迄)",
    "即將刪除推播請確認後執行": "<span class=\"cgRed\">即將刪除推播, 請確認後執行</span>",
    "請注意推播類型建立後將無法變更": "請注意, 推播類型建立後將無法變更",
    "全部會友名單": "全部會友名單",
    "選中的機構將不會發送推播訊息": "選中的機構將不會發送推播訊息",
    "即將新增推播內容": "即將新增推播內容",
    "請至少選擇 <b class=\"ft-24 text-danger\">1</b> 位會友進行推播": "請至少選擇 <b class=\"ft-24 text-danger\">1</b> 位會友進行推播",
    "即將更新推播內容": "即將更新推播內容",
    "請先建立服事群組": "請先建立服事群組",
    "選擇會友參與服事": "選擇會友參與服事",
    "最多只能選擇X位會友參與服事": "最多只能選擇%s位會友參與服事",
    "請選擇至少X位會友參與服事": "請選擇至少%s位會友參與服事",
    "參與群組": "參與群組",
    "請選擇參與群組": "請選擇參與群組",
    "請選擇會友參與服事": "請選擇會友參與服事",
    "搜尋不到指定的參與服事會友": "搜尋不到指定的參與服事會友",
    "結束時間必須大於開始時間": "結束時間必須大於開始時間",
    "請輸入說明": "請輸入說明",
    "請至少選擇1位會友參與服事": "請至少選擇1位會友參與服事",
    "請完善提醒的參數設定": "請完善提醒的參數設定",
    "請完善循環的參數設定": "請完善循環的參數設定",
    "目前服事處於僅讀取狀態無法更新": "目前服事處於僅讀取狀態無法更新",
    "目前服事處於停用狀態": "目前服事處於停用狀態",
    "參與人數": "參與人數",
    "已停用": "已停用",
    "啟用中": "啟用中",
    "即將啟用服事": "即將啟用服事",
    "即將停用服事": "即將停用服事",
    "即將刪除服事請確認後執行": "<span class=\"cgRed\">即將刪除服事, 請確認後執行</span>",
    "新增群組": "新增群組",
    "即將啟用群組": "即將啟用群組",
    "即將停用群組": "即將停用群組",
    "即將刪除群組請確認後執行": "<span class=\"cgRed\">即將刪除群組, 請確認後執行</span>",
    "即將新增群組": "即將新增群組",
    "請至少選擇1位人員參與服事": "請至少選擇1位人員參與服事",
    "請注意這個群組已經停用": "請注意, 這個群組已經停用",
    "即將更新群組內容": "即將更新群組內容",
    "周內新增": "周內新增",
    "月內新增": "月內新增",
    "離開人數": "離開人數",
    "群組建立": "群組建立",
    "加入群組": "加入群組",
    "從群組中離開": "從群組中離開",
    "新增服事": "新增服事",
    "開始日期起": "開始日期(起)",
    "開始日期迄": "開始日期(迄)",
    "結束日期起": "結束日期(起)",
    "結束日期迄": "結束日期(迄)",
    "請選擇開始日期起": "請選擇開始日期(起)",
    "請選擇開始日期迄": "請選擇開始日期(迄)",
    "請選擇結束日期起": "請選擇結束日期(起)",
    "請選擇結束日期迄": "請選擇結束日期(迄)",
    "說明": "說明",
    "其他資訊": "其他資訊",
    "請輸入備註": "請輸入備註",
    "請輸入其他資訊": "請輸入其他資訊",
    "即將新增服事": "即將新增服事",
    "請注意這個服事已經停用": "請注意, 這個服事已經停用",
    "即將更新服事內容": "即將更新服事內容",
    "奉獻匯出_會友管理": "奉獻匯出_會友管理",
    "奉獻日期起": "奉獻日期(起)",
    "奉獻日期迄": "奉獻日期(迄)",
    "訂單號": "訂單號",
    "奉獻金額": "奉獻金額",
    "請選擇奉獻日期起": "請選擇奉獻日期(起)",
    "請選擇奉獻日期迄": "請選擇奉獻日期(迄)",
    "請輸入訂單號": "請輸入訂單號",
    "即將進行奉獻匯出請確認後執行": "<span class=\"cgRed\">即將進行奉獻匯出, 請確認後執行</span>",
    "回應": "回應",
    "付款時間": "付款時間",
    "會友ID": "會友ID",
    "會友編號": "會友編號",
    "會友姓名": "會友姓名",
    "會友帳號": "會友帳號",
    "結果": "結果",
    "金流狀態": "金流狀態",
    "未填寫聯絡電話": "未填寫聯絡電話",
    "新增教學": "新增教學",
    "即將啟用教學": "即將啟用教學",
    "即將停用教學": "即將停用教學",
    "即將刪除教學請確認後執行": "<span class=\"cgRed\">即將刪除教學, 請確認後執行</span>",
    "請注意這個教學已經停用": "請注意, 這個教學已經停用",
    "來源": "來源",
    "此紀錄為未知來源": "此紀錄為未知來源",
    "流水號": "流水號",
    "存取方式": "存取方式",
    "遠端位置": "遠端位置",
    "存取路徑": "存取路徑",
    "請輸入方式": "請輸入方式",
    "請選擇結果": "請選擇結果",
    "等級": "等級",
    "結果代碼": "結果代碼",
    "攔截": "攔截",
    "請選擇模組": "請選擇模組",
    "攔截呼叫": "攔截呼叫",
    "標的教會": "標的教會",
    "標的物件流水號": "標的物件流水號",
    "攔截類": "攔截類",
    "攔截函式": "攔截函式",
    "回滾事務": "回滾事務",
    "副標題": "副標題",
    "提交參數": "提交參數",
    "無標題": "無標題",
    "無副標題": "無副標題",
    "無描述": "無描述",
    "樣本ID": "樣本ID",
    "請輸入樣本ID": "請輸入樣本ID",
    "角色": "角色",
    "請選擇角色": "請選擇角色",
    "樣本ID請輸入數字": "樣本ID請輸入數字",
    "發佈App": "發佈App",
    "請選擇發佈App": "請選擇發佈App",
    "即將新增紀錄": "即將新增紀錄",
    "即將更新紀錄": "即將更新紀錄",
    "同時搜尋標題與描述": "同時搜尋標題與描述",
    "請選擇作廢": "請選擇作廢",
    "建立人": "建立人",
    "請選擇建立人": "請選擇建立人",
    "請選擇上一次編輯人": "請選擇上一次編輯人",
    "即將作廢紀錄請確認後執行": "<span class=\"cgRed\">即將作廢紀錄, 請確認後執行</span>",
    "新增紀錄": "新增紀錄",
    "單號": "單號",
    "異常帳號": "異常帳號",
    "超時": "超時",
    "返工": "返工",
    "請輸入角色": "請輸入角色",
    "請輸入類型": "請輸入類型",
    "請輸入單號": "請輸入單號",
    "請選擇超時": "請選擇超時",
    "請選擇返工": "請選擇返工",
    "管理團隊": "管理團隊",
    "層級": "層級",
    "請選擇層級": "請選擇層級",
    "即將反饋至愛無界管理團隊": "即將反饋至愛無界管理團隊",
    "請認後執行": "請認後執行",
    "請注意這個反饋還未標示已讀取": "請注意, 這個反饋還未標示已讀取",
    "即將更新反饋內容": "即將更新反饋內容",
    "即將反饋至愛無界管理團隊請認後執行": "<b class=\"ft-20 text-danger\">即將反饋至愛無界管理團隊, 請認後執行</b>",
    "請我們喝咖啡匯出_客服管理": "請我們喝咖啡匯出_客服管理",
    "贊助日期起": "贊助日期(起)",
    "贊助日期迄": "贊助日期(迄)",
    "贊助金額": "贊助金額",
    "請選擇贊助日期起": "請選擇贊助日期(起)",
    "請選擇贊助日期迄": "請選擇贊助日期(迄)",
    "即將進行請我們喝咖啡匯出請確認後執行": "<span class=\"cgRed\">即將進行請我們喝咖啡匯出, 請確認後執行</span>",
    "請輸入完整的電子郵件": "請輸入完整的電子郵件",
    "會友已經停用": "會友已經停用",
    "會友已於X自行刪除": "會友已於 <b>%s</b> 自行刪除",
    "教會已經停用": "教會已經停用",
    "教會已經刪除": "教會已經刪除",
    "機構已經停用": "機構已經停用",
    "機構已經刪除": "機構已經刪除",
    "查詢到X筆紀錄": "查詢到 <b class=\"ft-18 text-success\">%s</b> 筆紀錄",
    "查詢不到任何結果": "查詢不到任何結果",
    "最後10筆推播通知": "最後 <b class=\"text-success ft-18\">10</b> 筆推播通知",
    "依照預定推播時間降冪排序": "(依照預定推播時間降冪排序)",
    "沒有推播通知紀錄": "沒有推播通知紀錄",
    "推播ID": "推播ID",
    "排定發送時間": "排定發送時間",
    "裝置支援商": "裝置支援商",
    "裝置製造商": "裝置製造商",
    "裝置型號": "裝置型號",
    "裝置操作系統": "裝置操作系統",
    "裝置App版本": "裝置App版本",
    "登入權杖": "登入權杖",
    "sys_tokentoken": "(sys_token.token)",
    "推播識別碼": "推播識別碼",
    "core_admin_client_notificationkey": "(core_admin_client_notification.key)",
    "所屬機構ID": "所屬機構ID",
    "所屬機構名稱": "所屬機構名稱",
    "更新時間": "更新時間",
    "請輸入完整的電子郵件進行查詢": "請輸入完整的電子郵件進行查詢",
    "直播數量": "直播數量",
    "新增直播": "新增直播",
    "請選擇文章整合": "請選擇文章整合",
    "即將啟用直播": "即將啟用直播",
    "即將停用直播": "即將停用直播",
    "即將刪除直播請確認後執行": "<span class=\"cgRed\">即將刪除直播, 請確認後執行</span>",
    "YouTube網址": "YouTube網址",
    "標籤-大廳": "標籤 - 大廳",
    "標籤-代禱": "標籤 - 代禱",
    "標籤-關於": "標籤 - 關於",
    "歡迎詞-大廳": "歡迎詞 - 大廳",
    "歡迎詞-代禱": "歡迎詞 - 代禱",
    "回應詞-代禱": "回應詞 - 代禱",
    "請輸入YouTube網址": "請輸入YouTube網址",
    "請輸入標籤大廳": "請輸入標籤(大廳)",
    "請輸入標籤代禱": "請輸入標籤(代禱)",
    "請輸入標籤關於": "請輸入標籤(關於)",
    "請輸入歡迎詞大廳": "請輸入歡迎詞(大廳)",
    "請輸入歡迎詞代禱": "請輸入歡迎詞(代禱)",
    "請輸入回應詞代禱": "請輸入回應詞(代禱)",
    "即將新增直播": "即將新增直播",
    "請輸入YouTube連結": "請輸入YouTube連結",
    "聊天室發言內容": "聊天室發言內容",
    "訪客": "訪客",
    "私密代禱內容": "私密代禱內容",
    "您即將查看會友私密個人資訊": "您即將查看會友私密個人資訊",
    "我將妥善與謹慎使用相關資訊": "我將妥善與謹慎使用相關資訊",
    "請注意這個直播已經停用": "請注意, 這個直播已經停用",
    "複製直播網址": "複製直播網址",
    "即將更新直播內容": "即將更新直播內容",
    "活動數量": "活動數量",
    "新增活動": "新增活動",
    "已報名": "已報名",
    "含未付費": "含未付費",
    "即將啟用活動": "即將啟用活動",
    "即將停用活動": "即將停用活動",
    "即將刪除活動請確認後執行": "<span class=\"cgRed\">即將刪除活動, 請確認後執行</span>",
    "活動建立人員將會自動擁有本活動App簽到功能可不指定其他協助簽到人員": "活動建立人員將會自動擁有本活動App簽到功能, 可不指定其他協助簽到人員",
    "已經開啟報名優惠功能無法修改日期": "已經開啟報名優惠功能, 無法修改日期",
    "活動開始時間": "活動開始時間",
    "活動結束時間": "活動結束時間",
    "請輸入活動開始時間": "請輸入活動開始時間",
    "請輸入活動結束時間": "請輸入活動結束時間",
    "即將新增活動": "即將新增活動",
    "請輸入回條描述": "請輸入回條描述",
    "團體報名人數最少X位最多X位": "團體報名人數最少 <b class=\"ft-16\">%s</b> 位, 最多 <b class=\"ft-16\">%s</b> 位",
    "還需要X位報名": ", 還需要 <b class=\"ft-16\">%s</b> 位報名",
    "最多還可以報名X位": ", 最多還可以報名 <b class=\"ft-16\">%s</b> 位",
    "已經達到活動報名人數上限": ", 已經達到活動報名人數上限",
    "已達到團報最高人數限制": ", 已達到團報最高人數限制",
    "報名總覽": "報名總覽",
    "請先增加團體報名人員": "請先增加團體報名人員",
    "合計X位報名": "合計 <b class=\"ft-16 text-success\">%s</b> 位報名",
    "原價": "原價",
    "X之前": "%s 之前",
    "新增團報人員": "新增團報人員",
    "編輯團報人員": "編輯團報人員",
    "活動場次": "活動場次",
    "支付狀態": "支付狀態",
    "教會機構名稱": "教會(機構)名稱",
    "教會機構所在城市": "教會(機構)所在城市",
    "聯絡人姓名": "聯絡人姓名",
    "聯絡人電話": "聯絡人電話",
    "聯絡人電子郵件": "聯絡人電子郵件",
    "郵遞區號": "郵遞區號",
    "通訊地址": "通訊地址",
    "請輸入教會機構名稱": "請輸入教會(機構)名稱",
    "請輸入教會機構所在城市": "請輸入教會(機構)所在城市",
    "請輸入聯絡人姓名": "請輸入聯絡人姓名",
    "請輸入聯絡人電話": "請輸入聯絡人電話",
    "請輸入聯絡人電子郵件": "請輸入聯絡人電子郵件",
    "請輸入郵遞區號": "請輸入郵遞區號",
    "請輸入通訊地址": "請輸入通訊地址",
    "即將儲存後台報名": "即將儲存後台報名",
    "請選擇報名方式": "請選擇報名方式",
    "指定的報名方式不存在": "指定的報名方式不存在",
    "請選擇活動場次": "請選擇活動場次",
    "指定的活動場次不存在": "指定的活動場次不存在",
    "指定的價格不存在": "指定的價格不存在",
    "請選擇支付狀態": "請選擇支付狀態",
    "指定的付款狀態不存在": "指定的付款狀態不存在",
    "總教會不能進行後台報名": "總教會不能進行後台報名",
    "即將返回報名內容頁面": "即將返回報名內容頁面",
    "活動報名已經額滿": "活動報名已經額滿",
    "聯絡人電子郵件格式錯誤": "聯絡人電子郵件格式錯誤",
    "請完善表單內容": "請完善表單內容",
    "需要收費": "需要收費",
    "限制人數": "限制人數",
    "報名上限": "報名上限",
    "等待付款": "等待付款",
    "報名完成": "報名完成",
    "剩餘名額": "剩餘名額",
    "後台編輯": "後台編輯",
    "聯絡人電話號碼": "聯絡人電話號碼",
    "報到二維碼": "報到二維碼",
    "報名場次": "報名場次",
    "場次開始": "場次開始",
    "場次結束": "場次結束",
    "全部X場": "全部 <b>%s</b> 場",
    "報名來源": "報名來源",
    "請輸入聯絡人電話號碼": "請輸入聯絡人電話號碼",
    "請選擇報名來源": "請選擇報名來源",
    "請選擇已付款": "請選擇已付款",
    "即將更新報名內容": "即將更新報名內容",
    "App": "App",
    "外部": "外部",
    "後台": "後台",
    "即將手動標記付款請確認後執行": "<span class=\"cgRed\">即將手動標記付款, 請確認後執行</span>",
    "請注意這個活動已經停用": "請注意, 這個活動已經停用",
    "請注意總教會登入無法使用後台報名": "請注意, 總教會登入無法使用後台報名",
    "請注意這個活動報名已經額滿": "請注意, 這個活動報名已經額滿",
    "請注意這個活動已經有X名會友已付費報名部分欄位無法修改請注意": "請注意, 這個活動已經有 <b class=\"ft-15\">%s</b> 名會友已付費報名, 部分欄位<b>無法修改</b>, 請注意",
    "活動已經開始報名截止": "活動已經開始, 報名截止",
    "下載二維碼": "下載二維碼",
    "報到工具": "報到工具",
    "顯示二維碼": "顯示二維碼",
    "複製報名網址": "複製報名網址",
    "報名資訊": "報名資訊",
    "報名網址": "報名網址",
    "即將更新活動內容": "即將更新活動內容",
    "密碼": "密碼",
    "即將更新個人內容": "即將更新個人內容",
    "更新密碼成功後將自動登出請您使用新密碼登入請確認後執行": "<b class=\"text-danger\">更新密碼成功後將自動登出<br/>請您使用新密碼登入, 請確認後執行</b>",
    "請輸入電話": "請輸入電話",
    "新增新朋友": "新增新朋友",
    "自行註冊": "自行註冊",
    "關係": "關係",
    "請確認將指定的會友標記為待轉入": "請確認將指定的會友<span class=\"text-danger\">標記為待轉入</span>",
    "請確認將指定的會友標記為不轉入": "請確認將指定的會友<span class=\"text-danger\">標記為不轉入</span>",
    "請確認將指定的會友轉入至牧養會友": "請確認將指定的會友<span class=\"text-danger\">轉入至牧養會友</span>",
    "請注意這名新朋友已經標記為不轉入": "請注意, 這名新朋友已經標記為不轉入",
    "未選擇所在地區": "未選擇所在地區",
    "未選擇所在城市": "未選擇所在城市",
    "更多選項": "更多選項",
    "收起選項": "收起選項",
    "為該族群的託管人員": "為該族群的託管人員",
    "未跟進": "未跟進",
    "已標註會友": "已標註會友",
    "加註": "加註",
    "連結": "連結",
    "所在區域": "所在區域",
    "請選擇需要篩選的族群": "請選擇需要篩選的族群",
    "請選擇稱謂": "請選擇稱謂",
    "請選擇職業": "請選擇職業",
    "請選擇教育程度": "請選擇教育程度",
    "請選擇五重執事": "請選擇五重執事",
    "請選擇婚姻狀況": "請選擇婚姻狀況",
    "即將對此會友進行加註": "即將對此會友進行加註",
    "即將對此會友移除加註": "即將對此會友移除加註",
    "即將刪除會友請確認後執行": "<span class=\"cgRed\">即將刪除會友, 請確認後執行</span>",
    "聚會": "聚會",
    "請選擇聚會": "請選擇聚會",
    "相關歷程": "相關歷程",
    "課程": "課程",
    "英文名字/暱稱": "英文名字/暱稱",
    "手機": "手機",
    "其他電話": "其他電話",
    "居住地址": "居住地址",
    "最高學校名稱": "最高學校名稱",
    "配偶名字": "配偶名字",
    "配偶聯絡方式": "配偶聯絡方式",
    "監護人名字": "監護人名字",
    "監護人關係": "監護人關係",
    "監護人聯絡方式": "監護人聯絡方式",
    "進入教會日期": "進入教會日期",
    "離開教會日期": "離開教會日期",
    "離開教會原因": "離開教會原因",
    "是否受洗": "是否受洗",
    "受洗日期": "受洗日期",
    "受洗教會": "受洗教會",
    "請輸入英文名字/暱稱": "請輸入英文名字/暱稱",
    "請選擇生日": "請選擇生日",
    "請輸入手機": "請輸入手機",
    "請輸入其他電話": "請輸入其他電話",
    "請輸入居住地址": "請輸入居住地址",
    "請輸入最高學校名稱": "請輸入最高學校名稱",
    "請輸入配偶名字": "請輸入配偶名字",
    "請輸入配偶聯絡方式": "請輸入配偶聯絡方式",
    "請輸入監護人名字": "請輸入監護人名字",
    "請輸入監護人關係": "請輸入監護人關係",
    "請輸入監護人聯絡方式": "請輸入監護人聯絡方式",
    "請選擇進入教會日期": "請選擇進入教會日期",
    "請選擇離開教會日期": "請選擇離開教會日期",
    "請輸入離開教會原因": "請輸入離開教會原因",
    "請填寫是否受洗": "請填寫是否受洗",
    "請選擇受洗日期": "請選擇受洗日期",
    "請輸入受洗教會": "請輸入受洗教會",
    "批次委派": "批次委派",
    "會友匯入": "會友匯入",
    "會友匯出": "會友匯出",
    "全部刪除": "全部刪除",
    "上一步": "上一步",
    "請先選擇族群": "請先選擇族群",
    "下一步": "下一步",
    "請先選擇會友": "請先選擇會友",
    "確認委派": "確認委派",
    "重新委派": "重新委派",
    "匯入會友檔案範例_完整": "匯入會友檔案範例_完整",
    "下載範例": "下載範例",
    "請先匯入會友資訊": "請先匯入會友資訊",
    "重新匯入": "重新匯入",
    "執行匯入": "執行匯入",
    "執行匯出": "執行匯出",
    "執行刪除": "執行刪除",
    "類別": "類別",
    "請選擇類別": "請選擇類別",
    "即將進行批次委派": "即將進行批次委派",
    "即將進行重新匯入": "即將進行重新匯入",
    "即將進行會友匯入": "即將進行會友匯入",
    "選項": "選項",
    "請先建立聚會分類": "請先建立聚會分類",
    "簽到工具顯示應到會友": "簽到工具顯示應到會友",
    "請選擇簽到工具顯示應到會友": "請選擇簽到工具顯示應到會友",
    "允許會友自行簽到": "允許會友自行簽到",
    "請選擇允許會友自行簽到": "請選擇允許會友自行簽到",
    "會友可自行於牧養對話中簽到": "會友可自行於牧養對話中簽到",
    "需要透過簽到工具或小組長出示掃描會友二維碼進行簽到": "需要透過簽到工具或小組長出示掃描會友二維碼進行簽到",
    "目前聚會處於僅讀取狀態無法更新": "目前聚會處於僅讀取狀態無法更新",
    "目前聚會處於停用狀態": "目前聚會處於停用狀態",
    "請選擇自行簽到": "請選擇自行簽到",
    "請完善選項的參數設定": "請完善選項的參數設定",
    "未開始": "未開始",
    "進行中": "進行中",
    "已結束": "已結束",
    "無聚會": "無聚會",
    "群族名稱": "群族名稱",
    "請輸入群族名稱": "請輸入群族名稱",
    "等待生成": "等待生成",
    "已生成": "已生成",
    "生成逾期": "生成逾期",
    "預計生成時間": "預計生成時間",
    "實際生成時間": "實際生成時間",
    "推送時間": "推送時間",
    "寄送郵件時間": "寄送郵件時間",
    "請先選擇所屬教會": "請先選擇所屬教會",
    "即將啟用聚會": "即將啟用聚會",
    "即將停用聚會": "即將停用聚會",
    "即將刪除聚會請確認後執行": "<span class=\"cgRed\">即將刪除聚會, 請確認後執行</span>",
    "新增類別": "新增類別",
    "即將新增類別": "即將新增類別",
    "即將更新類別內容": "即將更新類別內容",
    "新增聚會": "新增聚會",
    "需要透過簽到工具或小組長出示/掃描會友二維碼進行簽到": "需要透過簽到工具或小組長出示/掃描會友二維碼進行簽到",
    "首次": "首次",
    "請選擇是否允許會友自行簽到": "請選擇是否允許會友自行簽到",
    "請選擇簽到工具是否顯示應到會友": "請選擇簽到工具是否顯示應到會友",
    "即將新增聚會": "即將新增聚會",
    "請注意這個聚會已經停用": "請注意, 這個聚會已經停用",
    "下載報到介面二維碼": "下載報到介面二維碼",
    "前往報到介面": "前往報到介面",
    "顯示報到介面二維碼": "顯示報到介面二維碼",
    "複製報到介面網址": "複製報到介面網址",
    "即將更新聚會內容": "即將更新聚會內容",
    "聚會標題": "聚會標題",
    "聚會尚未開始": "聚會尚未開始",
    "聚會正在進行": "聚會正在進行",
    "聚會已經結束": "聚會已經結束",
    "重製點名單": "重製點名單",
    "聚會已經結束無法重製點名單": "聚會已經結束, 無法重製點名單",
    "X_報到介面二維碼": "%s_報到介面二維碼",
    "APP專用報到二維碼": "APP專用報到二維碼",
    "點擊下載": "點擊下載",
    "若您發現點名單成員不正確可進行點名單重製請確認後執行": "若您發現點名單成員不正確<br />可進行點名單重製, 請確認後執行",
    "請參考提醒設定值": "請參考提醒設定值",
    "不發送": "不發送",
    "等待發送": "等待發送",
    "正在準備發送": "正在準備發送",
    "發送完成": "發送完成",
    "預定生成時間": "預定生成時間",
    "預設提前生成": "預設提前生成",
    "推送狀態": "推送狀態",
    "推送完成時間": "推送完成時間",
    "寄送郵件狀態": "寄送郵件狀態",
    "寄送郵件完成時間": "寄送郵件完成時間",
    "請選擇預定生成時間": "請選擇預定生成時間",
    "展開全部統計": "展開全部統計",
    "收起全部統計": "收起全部統計",
    "新增族群": "新增族群",
    "新增同階族群": "新增同階族群",
    "新增子族群": "新增子族群",
    "回上一階": "回上一階",
    "組織圖": "組織圖",
    "無子族群供顯示組織圖": "無子族群供顯示組織圖",
    "無下一階": "無下一階",
    "下一階": "下一階",
    "該族群缺少託管人員請盡快編輯設定": "該族群缺少託管人員, 請盡快編輯設定",
    "查看聚會": "查看聚會",
    "已設定聚會無法刪除請先刪除已設定聚會": "已設定聚會, 無法刪除<br/>請先刪除已設定聚會",
    "已設定有子族群無法刪除請先刪除所有子族群": "已設定有子族群, 無法刪除<br/>請先刪除所有子族群",
    "託管人員-合計": "託管人員 - 合計",
    "族群成員": "族群成員",
    "族群成員-合計": "族群成員 - 合計",
    "即將重設該教會牧養相關功能包括牧養對話群組與聚會等相關功能重設將無法恢復請確認後執行": "<span class=\"cgRed\">即將重設該教會牧養相關功能<br/>包括牧養對話群組與聚會等相關功能<br/>重設將無法恢復, 請確認後執行</span>",
    "即將刪除族群刪除後牧養對話群組將會解散並無法恢復請確認後執行": "<span class=\"cgRed\">即將刪除族群, 刪除後牧養對話群組將會解散<br/>並無法恢復, 請確認後執行</span>",
    "合計次數": "合計次數",
    "暫無資料": "暫無資料",
    "列表對象為群組第一層全教會各佔比點選群組名稱可查閱下一級群組該牧區計算參與服事人數/總人數=全教會服事比例": "列表對象為群組第一層全教會各佔比，點選群組名稱可查閱下一級群組<br/><span class=\"text-danger\">該牧區計算: 參與服事人數 / 總人數 = 全教會服事比例</span>",
    "統計服事對象": "統計服事對象",
    "溫度服事對象": "溫度服事對象",
    "30天以上未參加": "30天以上未參加",
    "60天以上未參加": "60天以上未參加",
    "90天以上未參加": "90天以上未參加",
    "合計 <b class=\"text-success ft-15\">%s</b> 位": "合計 <b class=\"text-success ft-15\">%s</b> 位",
    "共X位": "共 <b class=\"text-%s ft-15\">%s</b> 位",
    "離開服事對象": "離開服事對象",
    "合計 <b class=\"text-danger ft-15\">%s</b> 位": "合計 <b class=\"text-danger ft-15\">%s</b> 位",
    "新增服事人數 <span class=\"ft-14\">(月)</span>": "新增服事人數 <span class=\"ft-14\">(月)</span>",
    "新增服事人數 <span class=\"ft-14\">(週)</span>": "新增服事人數 <span class=\"ft-14\">(週)</span>",
    "合計 <b class=\"text-info ft-15\">%s</b> 位": "合計 <b class=\"text-info ft-15\">%s</b> 位",
    "總人數": "總人數",
    "參與服事人數": "參與服事人數",
    "未參與服事人數": "未參與服事人數",
    "參與服事比例%": "參與服事比例 <span class=\"ft-12\">(%)</span>",
    "前月參與服事比例%": "前月參與服事比例 <span class=\"ft-12\">(%)</span>",
    "新增服事人數 <span class=\"ft-12\">(月)</span>": "新增服事人數 <span class=\"ft-12\">(月)</span>",
    "新增服事人數 <span class=\"ft-12\">(週)</span>": "新增服事人數 <span class=\"ft-12\">(週)</span>",
    "離開服事人數": "離開服事人數",
    "性別": "性別",
    "佔比": "佔比",
    "總和": "總和",
    "弟兄": "弟兄",
    "姐妹": "姐妹",
    "未登記": "未登記",
    "年齡": "年齡",
    "0-9歲": "0-9歲",
    "10-19歲": "10-19歲",
    "20-29歲": "20-29歲",
    "30-39歲": "30-39歲",
    "40-49歲": "40-49歲",
    "50-59歲": "50-59歲",
    "60-69歲": "60-69歲",
    "70-79歲": "70-79歲",
    "80-89歲": "80-89歲",
    "90-99歲": "90-99歲",
    "100-109歲": "100-109歲",
    "110-119歲": "110-119歲",
    "120-129歲": "120-129歲",
    "執事": "執事",
    "使徒": "使徒",
    "先知": "先知",
    "傳福音": "傳福音",
    "牧師": "牧師",
    "教師": "教師",
    "程度": "程度",
    "小學": "小學",
    "中學": "中學",
    "專科": "專科",
    "高中": "高中",
    "高職/高商": "高職/高商",
    "大學": "大學",
    "碩士": "碩士",
    "博士": "博士",
    "行政經營": "行政經營",
    "業務行銷": "業務行銷",
    "人事法務": "人事法務",
    "財會金融": "財會金融",
    "廣告美編": "廣告美編",
    "客戶服務": "客戶服務",
    "電腦硬體": "電腦硬體",
    "資訊軟體": "資訊軟體",
    "品管製造": "品管製造",
    "技術服務": "技術服務",
    "營建職業": "營建職業",
    "傳播媒體": "傳播媒體",
    "娛樂演藝": "娛樂演藝",
    "教育學術": "教育學術",
    "醫療美容": "醫療美容",
    "保全警衛": "保全警衛",
    "家事服務": "家事服務",
    "農林魚牧": "農林魚牧",
    "慈善宗教": "慈善宗教",
    "交通及物流服務": "交通及物流服務",
    "餐飲旅遊運動": "餐飲旅遊運動",
    "美容美髮": "美容美髮",
    "軍公教": "軍公教",
    "家管": "家管",
    "兒童": "兒童",
    "待業": "待業",
    "學生": "學生",
    "狀況": "狀況",
    "已婚": "已婚",
    "未婚": "未婚",
    "喪偶": "喪偶",
    "再婚": "再婚",
    "離婚": "離婚",
    "即將進行重建模擬請確認後執行": "<span class=\"cgRed\">即將進行重建模擬, 請確認後執行</span>",
    "即將進行模擬登入請確認後執行": "<span class=\"cgRed\">即將進行模擬登入, 請確認後執行</span>",
    "即將返回管理介面": "即將返回管理介面",
    "即將登出系統": "即將登出系統",
    "請確認登出": "請確認登出",
    "連線權杖逾時": "連線權杖逾時",
    "Oops🤕🤕請您重新登入系統": "Oops! 🤕🤕 請您重新登入系統",
    "未授權的存取": "未授權的存取",
    "Oops😳😳您可能沒有存取的權限": "Oops! 😳😳 您可能沒有存取的權限",
    "頁面不存在": "頁面不存在",
    "Oops😱😱您訪問的頁面不存在或暫時不可用": "Oops! 😱😱 您訪問的頁面不存在或暫時不可用",
    "這出了點小問題": "這出了點小問題",
    "Oops😵😵無法正確連結至伺服器": "Oops! 😵😵 無法正確連結至伺服器",
    "Oops🙁🙁您上傳的檔案容量超出限制": "Oops! 🙁🙁 您上傳的檔案容量超出限制",
    "Oops🥺🥺伺服器好像罷工了": "Oops! 🥺🥺 伺服器好像罷工了",
    "Oops😵‍💫😵‍💫連結到伺服器超出預期時間": "Oops! 😵‍💫😵‍💫 連結到伺服器超出預期時間",
    "上傳檔案發生錯誤": "上傳檔案發生錯誤",
    "單個檔案超過XX限制": "單個檔案超過 <b class=\"ft-20 text-danger\">%s</b> %s限制",
    "檔案合計超過XX限制": "檔案合計超過 <b class=\"ft-20 text-danger\">%s</b> %s限制",
    "產生預覽圖失敗": "產生預覽圖失敗",
    "上傳檔案中包含不支援的圖片編碼": "上傳檔案中包含不支援的圖片編碼",
    "分享連結出現錯誤": "分享連結出現錯誤",
    "請確認您的分享連結是否正確": "請確認您的分享連結是否正確",
    "二級驗證失敗": "二級驗證失敗",
    "請確認您的登入密碼是否正確": "請確認您的登入密碼是否正確",
    "Oops😲😲發生未知錯誤": "Oops! 😲😲 發生未知錯誤",
    "核准": "核准",
    "拒絕": "拒絕",
    "預覽": "預覽",
    "插入": "插入",
    "返回": "返回",
    "選擇": "選擇",
    "返回首頁": "返回首頁",
    "回列表": "回列表",
    "重新登入": "重新登入",
    "登入": "登入",
    "找回密碼": "找回密碼",
    "確認送出": "確認送出",
    "重設密碼": "重設密碼",
    "登入中": "登入中",
    "登入成功請稍候": "登入成功...請稍候",
    "好": "好",
    "回到頂部": "回到頂部",
    "儲存": "儲存",
    "變更": "變更",
    "查詢": "查詢",
    "重新讀取": "重新讀取",
    "取消": "取消",
    "送出": "送出",
    "完成": "完成",
    "重新整理": "重新整理",
    "取代": "取代",
    "前往": "前往",
    "執行教會編號": "執行教會編號",
    "執行教會名稱": "執行教會名稱",
    "剛剛": "剛剛",
    "%s分鐘前": "%s分鐘前",
    "%s小時前": "%s小時前",
    "X天前": "%s天前",
    "選擇年": "選擇年",
    "選擇月": "選擇月",
    "往前1年": "往前 1 年",
    "往前1個月": "往前 1 個月",
    "往前10年": "往前 10 年",
    "往後1年": "往後 1 年",
    "往後1個月": "往後 1 個月",
    "往後10年": "往後 10 年",
    "點擊使用滑桿模式": "點擊使用滑桿模式",
    "增加1小時": "增加 1 小時",
    "增加X分鐘": "增加 %s 分鐘",
    "減少1小時": "減少 1 小時",
    "減少X分鐘": "減少 %s 分鐘",
    "小於最早時間限制": "小於最早時間限制",
    "最早時間限制為X請您重新選擇": "最早時間限制為 <b class=\"ft-20 text-danger\">%s</b><br />請您重新選擇",
    "大於最晚時間限制": "大於最晚時間限制",
    "最晚時間限制為X請您重新選擇": "最晚時間限制為 <b class=\"ft-20 text-danger\">%s</b><br />請您重新選擇",
    "牧養相關功能暫停使用": "牧養相關功能暫停使用",
    "該功能目前處於維護狀態暫時無法使用開放時間將另行通知造成您的不便請多見諒": "該功能目前處於維護狀態暫時無法使用<br/>開放時間將另行通知, 造成您的不便請多見諒",
    "操作成功": "操作成功",
    "服務降級保護中": "服務降級保護中",
    "服務目前處於降級保護的狀態請稍後再試": "服務目前處於降級保護的狀態, 請稍後再試",
    "服務流控管制中": "服務流控管制中",
    "服務目前處於流控管制的狀態請稍後再試": "服務目前處於流控管制的狀態, 請稍後再試",
    "服務熱點限制中": "服務熱點限制中",
    "服務目前處於熱點限制的狀態請稍後再試": "服務目前處於熱點限制的狀態, 請稍後再試",
    "系統規則不滿足要求": "系統規則不滿足要求",
    "請稍後再試": "請稍後再試",
    "授權規則不通過": "授權規則不通過",
    "連線權杖逾時或不正確": "連線權杖逾時或不正確",
    "公司授權已經到期": "公司授權已經到期",
    "請向我們的銷售人員聯絡謝謝": "請向我們的銷售人員聯絡, 謝謝",
    "無存取權限": "無存取權限",
    "Oops😵😵存取的服務存在異常": "Oops! 😵😵 存取的服務存在異常",
    "Oops😵😵連結到伺服器超出預期時間": "Oops! 😵😵 連結到伺服器超出預期時間",
    "Oops😵😵系統模組連接異常": "Oops! 😵😵 系統模組連接異常",
    "基本": "基本",
    "標記為": "標記為",
    "為必填欄位": "為必填欄位",
    "點擊停用": "點擊停用",
    "點擊啟用": "點擊啟用",
    "無資料": "無資料",
    "更新": "更新",
    "設定的所有循環均已完成, 將不會再繼續生成相關單據與提醒": "設定的所有循環均已完成, 將不會再繼續生成相關單據與提醒",
    "已達選項上限": "已達選項上限",
    "自訂": "自訂",
    "新增提醒": "新增提醒",
    "提前生成": "提前生成",
    "載入中": "載入中",
    "正在計算統計數據...": "正在計算統計數據...",
    "可選擇 %s 位會友": "可選擇 %s 位會友",
    "已選擇 %s 位會友": "已選擇 %s 位會友",
    "異動項目將會清除, 請確認後執行": "異動項目將會清除, 請確認後執行",
    "提醒時間": "提醒時間",
    "分鐘前": "分鐘前",
    "小時前": "小時前",
    "日前": "日前",
    "週前": "週前",
    "電子郵件清單": "電子郵件清單",
    "循環明細": "循環明細",
    "此服事為單次循環": "此服事為單次循環",
    "選擇成員": "選擇成員",
    "會友": "會友",
    "搜尋範圍: 名字/郵件/編號": "搜尋範圍: 名字/郵件/編號",
    "無可選名單": "無可選名單",
    "尚未選擇名單": "尚未選擇名單",
    "可選": "可選",
    "名會友": "名會友",
    "已選": "已選",
    "查無符合的名單": "查無符合的名單",
    "最多可選": "最多可選",
    "還可選": "還可選",
    "新增信箱": "新增信箱",
    "請先於基本分頁設定開始與結束時間": "請先於基本分頁設定開始與結束時間",
    "尚未選擇參與人員": "尚未選擇參與人員",
    "請至少選擇一位參與人員後再儲存": "請至少選擇一位參與人員後再儲存",
    "提醒設定尚未完成": "提醒設定尚未完成",
    "尚未選擇提醒時間": "尚未選擇提醒時間",
    "請至少勾選一項提醒時間": "請至少勾選一項提醒時間",
    "選擇 Email 通知時，請至少填寫一個有效的電子郵件": "選擇 Email 通知時，請至少填寫一個有效的電子郵件",
    "循環設定尚未完成": "循環設定尚未完成",
    "分": "分",
    "時": "時",
    "教會新增成功": "教會新增成功",
    "教會內容更新成功": "教會內容更新成功",
    "時區與機構設定": "時區與機構設定",
    "時區設定": "時區設定",
    "請點擊圖示產生隨機邀請碼": "請點擊圖示產生隨機邀請碼",
    "請點擊圖示自行輸入邀請碼": "請點擊圖示自行輸入邀請碼",
    "共計": "共計",
    "次閱讀": "次閱讀",
    "篩選出": "篩選出",
    "筆公告": "筆公告",
    "尚未選擇收件人": "尚未選擇收件人",
    "目前沒有任何推播": "目前沒有任何推播",
    "請選擇排程": "請選擇排程",
    "建立日期(起)": "建立日期(起)",
    "建立日期(迄)": "建立日期(迄)",
    "左上": "左上",
    "右上": "右上",
    "置中": "置中",
    "左下": "左下",
    "右下": "右下",
    "圖片處理中, 請稍候": "圖片處理中, 請稍候",
    "已經編輯的內容將會重設, 請確認後執行": "已經編輯的內容將會重設, 請確認後執行",
    "新增文字": "新增文字",
    "刪除文字": "刪除文字",
    "請先選擇文字": "請先選擇文字",
    "背景顏色": "背景顏色",
    "請選擇背景顏色": "請選擇背景顏色",
    "靠左": "靠左",
    "靠右": "靠右",
    "文字描邊": "文字描邊",
    "描邊粗細": "描邊粗細",
    "描邊顏色": "描邊顏色",
    "請選擇描邊顏色": "請選擇描邊顏色",
    "文字陰影": "文字陰影",
    "陰影模糊": "陰影模糊",
    "陰影顏色": "陰影顏色",
    "請選擇陰影顏色": "請選擇陰影顏色",
    "底色濃度": "底色濃度",
    "文字底色": "文字底色",
    "請選擇文字底色": "請選擇文字底色",
    "旋轉翻轉": "旋轉翻轉",
    "縮放": "縮放",
    "濾鏡": "濾鏡",
    "亮度": "亮度",
    "對比": "對比",
    "飽和度": "飽和度",
    "選擇下方工具開始編輯": "選擇下方工具開始編輯",
    "自訂顏色": "自訂顏色",
    "向左旋轉": "向左旋轉",
    "向右旋轉": "向右旋轉",
    "水平翻轉": "水平翻轉",
    "垂直翻轉": "垂直翻轉",
    "點畫布上的文字可以編輯它": "點畫布上的文字可以編輯它",
    "顏色": "顏色",
    "描邊": "描邊",
    "陰影": "陰影",
    "底色": "底色",
    "背景": "背景",
    "使用這張圖": "使用這張圖",
    "復原": "復原",
    "重做": "重做",
    "上傳貼圖": "上傳貼圖",
    "貼圖": "貼圖",
    "透明度": "透明度",
    "拖曳可以移動, 拉四個角可以縮放": "拖曳可以移動, 拉四個角可以縮放",
    "位置": "位置",
    "水平對齊": "水平對齊",
    "垂直對齊": "垂直對齊",
    "文字對齊": "文字對齊",
    "靠上": "靠上",
    "靠下": "靠下",
    "疊放順序": "疊放順序",
    "上移一層": "上移一層",
    "下移一層": "下移一層",
    "拖曳時會自動吸附對齊; 方向鍵可微調, 按住 Shift 移動較快": "拖曳時會自動吸附對齊; 方向鍵可微調, 按住 Shift 移動較快",

    // ---- 文章管理（心靈捕手匯入 / 複製 / 共用） ----
    "文章複製成功": "文章複製成功",
    "僅能指定自行維護文章的教會": "僅能指定自行維護文章的教會",
    "即將匯入心靈捕手文章": "即將匯入心靈捕手文章",
    "文章新增成功": "文章新增成功",
    "封面圖來源讀取失敗，請自行上傳封面圖": "封面圖來源讀取失敗，請自行上傳封面圖",
    "尚未完成必填欄位": "尚未完成必填欄位",

    // ---- 補齊：頁面已使用但先前未定義的中文 key（2026-08 全庫掃描）----
    "(依照預定推播時間降冪排序)": "(依照預定推播時間降冪排序)",
    "MP3 連結": "MP3 連結",
    "上架時間需早於活動開始時間": "上架時間需早於活動開始時間",
    "上架時間需早於直播開始時間": "上架時間需早於直播開始時間",
    "主要聯絡人": "主要聯絡人",
    "個人內容更新成功": "個人內容更新成功",
    "優惠": "優惠",
    "免費活動無法使用線上支付": "免費活動無法使用線上支付",
    "全體推播請選擇要排除的機構": "全體推播請選擇要排除的機構",
    "公告停用成功": "公告停用成功",
    "公告刪除成功": "公告刪除成功",
    "公告啟用成功": "公告啟用成功",
    "共": "共",
    "分類停用成功": "分類停用成功",
    "分類刪除成功": "分類刪除成功",
    "分類啟用成功": "分類啟用成功",
    "刪除後將無法復原, 請確認後執行": "刪除後將無法復原, 請確認後執行",
    "剩餘": "剩餘",
    "即將標示已付款": "即將標示已付款",
    "反饋內容更新成功": "反饋內容更新成功",
    "取消置頂成功": "取消置頂成功",
    "可選會友": "可選會友",
    "回應詞 - 代禱": "回應詞 - 代禱",
    "回條封面圖": "回條封面圖",
    "回條描述": "回條描述",
    "報名內容更新成功": "報名內容更新成功",
    "報名成功後寄送給報名者的回條（封面圖與說明）": "報名成功後寄送給報名者的回條（封面圖與說明）",
    "場": "場",
    "場次變更成功": "場次變更成功",
    "奉獻日期(起)": "奉獻日期(起)",
    "奉獻日期(迄)": "奉獻日期(迄)",
    "如果不需要變更密碼, 不用填寫": "如果不需要變更密碼, 不用填寫",
    "尚未選擇排除機構": "尚未選擇排除機構",
    "尚無留言": "尚無留言",
    "尚無資料": "尚無資料",
    "已整合": "已整合",
    "已為您轉交愛無界團隊": "已為您轉交愛無界團隊",
    "已讀": "已讀",
    "已達優惠數量上限": "已達優惠數量上限",
    "已達電子郵件數量上限": "已達電子郵件數量上限",
    "已選會友": "已選會友",
    "建立時間(起)": "建立時間(起)",
    "建立時間(迄)": "建立時間(迄)",
    "影音連結": "影音連結",
    "待付款": "待付款",
    "待送出": "待送出",
    "拖拉排序": "拖拉排序",
    "拖拉調整排序": "拖拉調整排序",
    "指定推播請至少選擇一位收件人後再儲存": "指定推播請至少選擇一位收件人後再儲存",
    "指定推播需選擇收件人後才能儲存": "指定推播需選擇收件人後才能儲存",
    "挑選名單": "挑選名單",
    "推播刪除成功": "推播刪除成功",
    "提醒方式": "提醒方式",
    "搜尋名稱 / 信箱": "搜尋名稱 / 信箱",
    "收費": "收費",
    "教學停用成功": "教學停用成功",
    "教學刪除成功": "教學刪除成功",
    "教學啟用成功": "教學啟用成功",
    "教會(機構)名稱": "教會(機構)名稱",
    "教會(機構)所在城市": "教會(機構)所在城市",
    "教會名稱": "教會名稱",
    "教會編號": "教會編號",
    "整合文章的內文圖片，可上傳多張並排序": "整合文章的內文圖片，可上傳多張並排序",
    "文章停用成功": "文章停用成功",
    "文章刪除成功": "文章刪除成功",
    "文章啟用成功": "文章啟用成功",
    "文章留言刪除成功": "文章留言刪除成功",
    "文章置頂成功": "文章置頂成功",
    "新增優惠": "新增優惠",
    "暫時沒有可排序的資料": "暫時沒有可排序的資料",
    "暫無填寫資料": "暫無填寫資料",
    "最多報名人數": "最多報名人數",
    "最少報名人數": "最少報名人數",
    "未命名場次": "未命名場次",
    "未命名欄位": "未命名欄位",
    "未整合": "未整合",
    "未設定優惠": "未設定優惠",
    "查無資料": "查無資料",
    "標示已付款成功": "標示已付款成功",
    "標籤 - 代禱": "標籤 - 代禱",
    "標籤 - 大廳": "標籤 - 大廳",
    "標籤 - 關於": "標籤 - 關於",
    "欄位種類": "欄位種類",
    "次要聯絡人": "次要聯絡人",
    "歡迎詞 - 代禱": "歡迎詞 - 代禱",
    "歡迎詞 - 大廳": "歡迎詞 - 大廳",
    "此推播已完成，僅供查看無法修改": "此推播已完成，僅供查看無法修改",
    "此教會尚未開通線上支付": "此教會尚未開通線上支付",
    "此活動已有報名，既有欄位已鎖定不可修改；仍可新增欄位，但新增的欄位不可設為必填。": "此活動已有報名，既有欄位已鎖定不可修改；仍可新增欄位，但新增的欄位不可設為必填。",
    "活動停用成功": "活動停用成功",
    "活動刪除成功": "活動刪除成功",
    "活動啟用成功": "活動啟用成功",
    "活動已有報名，新增的欄位不可設為必填": "活動已有報名，新增的欄位不可設為必填",
    "清除邀請碼": "清除邀請碼",
    "留言數量重算完成": "留言數量重算完成",
    "登入成功...請稍候": "登入成功...請稍候",
    "目前推播正在進行中無法修改": "目前推播正在進行中無法修改",
    "直播停用成功": "直播停用成功",
    "直播刪除成功": "直播刪除成功",
    "直播啟用成功": "直播啟用成功",
    "確定要停用此服事嗎？": "確定要停用此服事嗎？",
    "確定要刪除此推播嗎？": "確定要刪除此推播嗎？",
    "確定要刪除此服事嗎？": "確定要刪除此服事嗎？",
    "確定要啟用此服事嗎？": "確定要啟用此服事嗎？",
    "確定要重設嗎？": "確定要重設嗎？",
    "社群分享（LINE／Facebook 等）預覽時顯示的文字": "社群分享（LINE／Facebook 等）預覽時顯示的文字",
    "第": "第",
    "筆": "筆",
    "系統": "系統",
    "結束日期": "結束日期",
    "結束時間(起)": "結束時間(起)",
    "結束時間(迄)": "結束時間(迄)",
    "編輯收件人名單": "編輯收件人名單",
    "總報名": "總報名",
    "自行輸入": "自行輸入",
    "若只有一個場次，此頁籤不用填寫": "若只有一個場次，此頁籤不用填寫",
    "藍新金流Hash IV": "藍新金流Hash IV",
    "藍新金流Hash KEY": "藍新金流Hash KEY",
    "藍新金流Merchant ID": "藍新金流Merchant ID",
    "請注意, 這個分類已經停用": "請注意, 這個分類已經停用",
    "請注意, 這個教學已經停用": "請注意, 這個教學已經停用",
    "請注意, 這個直播已經停用": "請注意, 這個直播已經停用",
    "請至少填寫一組電子郵件": "請至少填寫一組電子郵件",
    "請至少選擇一位收件人": "請至少選擇一位收件人",
    "請至少選擇一位會友進行推播": "請至少選擇一位會友進行推播",
    "請至少選擇一種提醒方式": "請至少選擇一種提醒方式",
    "請輸入 Google 雲端 MP3 連結": "請輸入 Google 雲端 MP3 連結",
    "請輸入 MP3 連結": "請輸入 MP3 連結",
    "請輸入 YouTube 連結": "請輸入 YouTube 連結",
    "請輸入回應詞(代禱)": "請輸入回應詞(代禱)",
    "請輸入影音連結": "請輸入影音連結",
    "請輸入教會(機構)名稱": "請輸入教會(機構)名稱",
    "請輸入教會(機構)所在城市": "請輸入教會(機構)所在城市",
    "請輸入標籤(代禱)": "請輸入標籤(代禱)",
    "請輸入標籤(大廳)": "請輸入標籤(大廳)",
    "請輸入標籤(關於)": "請輸入標籤(關於)",
    "請輸入歡迎詞(代禱)": "請輸入歡迎詞(代禱)",
    "請輸入歡迎詞(大廳)": "請輸入歡迎詞(大廳)",
    "請輸入活動內容": "請輸入活動內容",
    "請輸入藍新金流Hash IV": "請輸入藍新金流Hash IV",
    "請輸入藍新金流Hash KEY": "請輸入藍新金流Hash KEY",
    "請輸入藍新金流Merchant ID": "請輸入藍新金流Merchant ID",
    "請輸入費用": "請輸入費用",
    "請選擇": "請選擇",
    "請選擇來源": "請選擇來源",
    "請選擇場次": "請選擇場次",
    "請選擇建立日期(起)": "請選擇建立日期(起)",
    "請選擇建立日期(迄)": "請選擇建立日期(迄)",
    "請選擇收件人": "請選擇收件人",
    "請選擇等級": "請選擇等級",
    "請選擇結束時間(迄)": "請選擇結束時間(迄)",
    "請選擇讀取狀態": "請選擇讀取狀態",
    "請選擇開啟狀態": "請選擇開啟狀態",
    "請選擇贊助日期(起)": "請選擇贊助日期(起)",
    "請選擇贊助日期(迄)": "請選擇贊助日期(迄)",
    "請選擇開始時間(起)": "請選擇開始時間(起)",
    "贊助日期(起)": "贊助日期(起)",
    "贊助日期(迄)": "贊助日期(迄)",
    "起始日期": "起始日期",
    "開始日期": "開始日期",
    "開始時間(起)": "開始時間(起)",
    "開始時間(迄)": "開始時間(迄)",
    "附加": "附加",
    "隨機產生": "隨機產生",
    "需要早於直播開始時間": "需要早於直播開始時間",
    "需透過簽到工具或小組長掃描二維碼簽到": "需透過簽到工具或小組長掃描二維碼簽到",
    "頁": "頁",
    "預設發送": "預設發送",
    "點擊更換驗證碼": "點擊更換驗證碼",
    "啟動圖排程": "啟動圖排程",

    // ===== APP首頁（第三個 Portal，目前只開放 org=4）=====
    "URL": "URL",
    "序號": "序號",
    "YouTube 影片與 MP3 音檔": "YouTube 影片與 MP3 音檔",
    "代禱需求": "代禱需求",
    "儲存中...": "儲存中...",
    "儲存設定": "儲存設定",
    "分類新增成功": "分類新增成功",
    "分類更新成功": "分類更新成功",
    "各系列底下的訊息內容": "各系列底下的訊息內容",
    "團隊管理": "團隊管理",
    "團隊類型": "團隊類型",
    "封面、聚會時間、社群連結與地圖": "封面、聚會時間、社群連結與地圖",
    "封面圖片": "封面圖片",
    "封面影片": "封面影片",
    "封面設計": "封面設計",
    "封面類型": "封面類型",
    "小組": "小組",
    "建議上傳 16:9 比例的圖片": "建議上傳 16:9 比例的圖片",
    "建議上傳 16:9 比例的圖片，用於展示在首頁或其他頁面的頂部": "建議上傳 16:9 比例的圖片，用於展示在首頁或其他頁面的頂部",
    "建議上傳 16:9 比例的圖片，用於接受耶穌的頁面顯示": "建議上傳 16:9 比例的圖片，用於接受耶穌的頁面顯示",
    "建議上傳 1:1 正方形的圖片": "建議上傳 1:1 正方形的圖片",
    "建議上傳 1:1 正方形的圖片，前台會裁成圓形": "建議上傳 1:1 正方形的圖片，前台會裁成圓形",
    "建議使用 25:10 比例": "建議使用 25:10 比例",
    "影片": "影片",
    "影片或 mp3 網址": "影片或 mp3 網址",
    "成員刪除成功": "成員刪除成功",
    "成員新增成功": "成員新增成功",
    "成員更新成功": "成員更新成功",
    "所屬分類": "所屬分類",
    "接受耶穌圖片": "接受耶穌圖片",
    "接受耶穌登錄": "接受耶穌登錄",
    "提交時間": "提交時間",
    "搜尋姓名、電話或信箱...": "搜尋姓名、電話或信箱...",
    "搜尋姓名或職稱": "搜尋姓名或職稱",
    "搜尋標題、副標題或內容": "搜尋標題、副標題或內容",
    "搜尋標題、描述或內容": "搜尋標題、描述或內容",
    "搜尋標題、描述或連結": "搜尋標題、描述或連結",
    "搜尋標題或描述": "搜尋標題或描述",
    "支援 YouTube、Vimeo 等影片連結或 mp3 等音訊檔連結": "支援 YouTube、Vimeo 等影片連結或 mp3 等音訊檔連結",
    "敬拜刪除成功": "敬拜刪除成功",
    "敬拜新增成功": "敬拜新增成功",
    "敬拜更新成功": "敬拜更新成功",
    "敬拜管理": "敬拜管理",
    "新增成員": "新增成員",
    "新增敬拜": "新增敬拜",
    "新增訊息": "新增訊息",
    "新增關鍵字": "新增關鍵字",
    "方便聯繫時間": "方便聯繫時間",
    "APP首頁": "APP首頁",
    "標記為已處理": "標記為已處理",
    "標記為無效": "標記為無效",
    "決志留言": "決志留言",
    "決志表單的留言與處理狀態": "決志表單的留言與處理狀態",
    "活動回顧": "活動回顧",
    "活動新增成功": "活動新增成功",
    "活動更新成功": "活動更新成功",
    "活動照片與連結": "活動照片與連結",
    "無": "無",
    "照片": "照片",
    "牧師、長老與傳道團隊成員": "牧師、長老與傳道團隊成員",
    "狀態已更新": "狀態已更新",
    "目前有": "目前有",
    "確定要刪除這位成員嗎？": "確定要刪除這位成員嗎？",
    "確定要刪除這個分類嗎？": "確定要刪除這個分類嗎？",
    "確定要刪除這個活動嗎？": "確定要刪除這個活動嗎？",
    "確定要刪除這個關鍵字嗎？": "確定要刪除這個關鍵字嗎？",
    "確定要刪除這則訊息嗎？": "確定要刪除這則訊息嗎？",
    "確定要刪除這首敬拜嗎？": "確定要刪除這首敬拜嗎？",
    "確定要標記為已處理嗎？": "確定要標記為已處理嗎？",
    "確定要標記為無效嗎？": "確定要標記為無效嗎？",
    "確認": "確認",
    "社群媒體連結": "社群媒體連結",
    "筆未處理的決志留言": "筆未處理的決志留言",
    "簡介": "簡介",
    "簡短描述": "簡短描述",
    "精選分類": "精選分類",
    "精選訊息": "精選訊息",
    "精選訊息的系列分類": "精選訊息的系列分類",
    "網址格式不正確": "網址格式不正確",
    "編輯分類": "編輯分類",
    "編輯成員": "編輯成員",
    "編輯敬拜": "編輯敬拜",
    "編輯活動": "編輯活動",
    "編輯訊息": "編輯訊息",
    "編輯關鍵字": "編輯關鍵字",
    "聯絡資訊": "聯絡資訊",
    "聯繫方式": "聯繫方式",
    "職稱": "職稱",
    "至": "至",
    "訊息刪除成功": "訊息刪除成功",
    "訊息新增成功": "訊息新增成功",
    "訊息更新成功": "訊息更新成功",
    "詳細內容": "詳細內容",
    "請輸入 Google Map URL": "請輸入 Google Map URL",
    "請輸入 MP3 網址": "請輸入 MP3 網址",
    "請輸入 YouTube 網址": "請輸入 YouTube 網址",
    "請輸入副標題": "請輸入副標題",
    "請輸入影片網址（YouTube、Vimeo等）": "請輸入影片網址（YouTube、Vimeo等）",
    "請輸入影片網址，支援 YouTube、Vimeo 等影片平台的連結": "請輸入影片網址，支援 YouTube、Vimeo 等影片平台的連結",
    "請輸入成員簡介...": "請輸入成員簡介...",
    "請輸入排序號碼": "請輸入排序號碼",
    "請輸入活動標題": "請輸入活動標題",
    "請輸入活動連結": "請輸入活動連結",
    "請輸入簡短描述": "請輸入簡短描述",
    "請輸入網址": "請輸入網址",
    "請輸入聚會時間": "請輸入聚會時間",
    "請輸入職稱": "請輸入職稱",
    "請選擇團隊類型": "請選擇團隊類型",
    "請選擇所屬分類": "請選擇所屬分類",
    "資訊設定": "資訊設定",
    "資訊設定儲存成功": "資訊設定儲存成功",
    "這裡維護的是 App 首頁與官網的內容，存檔後即時生效": "這裡維護的是 App 首頁與官網的內容，存檔後即時生效",
    "關於我們": "關於我們",
    "關鍵字刪除成功": "關鍵字刪除成功",
    "關鍵字新增成功": "關鍵字新增成功",
    "關鍵字更新成功": "關鍵字更新成功",
    "關鍵字管理": "關鍵字管理",
    "類型為 YouTube 時，網址必須是 youtube.com 或 youtu.be": "類型為 YouTube 時，網址必須是 youtube.com 或 youtu.be",
    "首頁的熱門搜尋關鍵字": "首頁的熱門搜尋關鍵字",
    "唯讀：您沒有編輯此活動的權限，僅能檢視內容": "唯讀：您沒有編輯此活動的權限，僅能檢視內容",
    "唯讀：您沒有新增活動的權限，僅能檢視內容": "唯讀：您沒有新增活動的權限，僅能檢視內容",
    "唯讀：您沒有更新報名內容的權限，僅能檢視內容": "唯讀：您沒有更新報名內容的權限，僅能檢視內容",
    "唯讀：您沒有後台報名的權限，僅能檢視表單": "唯讀：您沒有後台報名的權限，僅能檢視表單",
    "報到名單": "報到名單",
    "已報到": "已報到",
    "應到": "應到",
    "報到狀態": "報到狀態",
    "報到時間": "報到時間",
    "報到人員": "報到人員",
    "後台標記": "後台標記",
    "標示已報到": "標示已報到",
    "取消報到": "取消報到",
    "即將標示已報到": "即將標示已報到",
    "即將取消報到": "即將取消報到",
    "標示已報到成功": "標示已報到成功",
    "取消報到成功": "取消報到成功",
    "請輸入姓名或電子郵件": "請輸入姓名或電子郵件",
    "請選擇報到狀態": "請選擇報到狀態",
    "出席": "出席",
    "已自評": "已自評",
    "已留言": "已留言",
    "請選擇聚會排程": "請選擇聚會排程",
    "Email": "Email",
    "簽到時間": "簽到時間",
    "簽到方式": "簽到方式",
    "Web 報到介面": "Web 報到介面",
    "請輸入姓名/Email/手機": "請輸入姓名/Email/手機",
    "聚會類型": "聚會類型",
    "請選擇聚會類型": "請選擇聚會類型",
    "聚會類型建立後不可修改": "聚會類型建立後不可修改",
    "掃描手可使用 App「實用工具 › 聚會掃描手」掃描會友行動條碼簽到，時間為排程開始前後 4 小時": "掃描手可使用 App「實用工具 › 聚會掃描手」掃描會友行動條碼簽到，時間為排程開始前後 4 小時",
    "已選擇掃描手": "已選擇掃描手",
    "尚未選擇掃描手": "尚未選擇掃描手",
    "新增掃描手": "新增掃描手",
    "已選擇": "已選擇",
    "載入更多": "載入更多",
    // 教會管理 - 頻道管理
    "頻道管理": "頻道管理",
    "頻道名稱": "頻道名稱",
    "留空則沿用教會名稱": "留空則沿用教會名稱",
    "頻道名稱最多100個字": "頻道名稱最多100個字",
    "即將更新頻道設定": "即將更新頻道設定",
    "此頁籤獨立儲存，頻道名稱與管理員會同步到 App 聊天的教會推播頻道": "此頁籤獨立儲存，頻道名稱與管理員會同步到 App 聊天的教會推播頻道",
    "頻道管理員需為本教會的 App 會友，可在 App 聊天中管理教會推播頻道": "頻道管理員需為本教會的 App 會友，可在 App 聊天中管理教會推播頻道",
    "已選擇頻道管理員": "已選擇頻道管理員",
    "尚未選擇頻道管理員": "尚未選擇頻道管理員",
    "新增頻道管理員": "新增頻道管理員",
    // App 錯誤追蹤
    "App 錯誤追蹤": "App 錯誤追蹤",
    "近14天事件數": "近14天事件數",
    "事件數": "事件數",
    "復發": "復發",
    "錯誤": "錯誤",
    "區間次數": "區間次數",
    "總次數": "總次數",
    "最後版本": "最後版本",
    "首次出現": "首次出現",
    "最後出現": "最後出現",
    "平台": "平台",
    "版本": "版本",
    "錯誤類別 / 訊息": "錯誤類別 / 訊息",
    "發生日期(起)": "發生日期(起)",
    "發生日期(迄)": "發生日期(迄)",
    "請選擇發生日期(起)": "請選擇發生日期(起)",
    "請選擇發生日期(迄)": "請選擇發生日期(迄)",
    "標記已解決": "標記已解決",
    "標記為已解決": "標記為已解決",
    "之後若收到更新版本（build 大於下方填寫值）的事件，會自動重新開啟並標記為復發。": "之後若收到更新版本（build 大於下方填寫值）的事件，會自動重新開啟並標記為復發。",
    "忽略": "忽略",
    "忽略此錯誤": "忽略此錯誤",
    "忽略後新事件只會計數，不會再重新開啟。": "忽略後新事件只會計數，不會再重新開啟。",
    "重新開啟": "重新開啟",
    "重新開啟此錯誤": "重新開啟此錯誤",
    "狀態將改回未解決。": "狀態將改回未解決。",
    "解決於": "解決於",
    "解決於 Build": "解決於 Build",
    "解決於版本": "解決於版本",
    "選填": "選填",
    "Build 必須是正整數": "Build 必須是正整數",
    "未處理": "未處理",
    "影響裝置數": "影響裝置數",
    "影響會友數": "影響會友數",
    "依近90天事件計算": "依近90天事件計算",
    "每日事件數": "每日事件數",
    "天": "天",
    "分布": "分布",
    "事件內容": "事件內容",
    "此錯誤沒有可檢視的事件明細（事件只保留 90 天，或因取樣未存明細）": "此錯誤沒有可檢視的事件明細（事件只保留 90 天，或因取樣未存明細）",
    "訊息": "訊息",
    "堆疊": "堆疊",
    "系統版本": "系統版本",
    "語系": "語系",
    "App 版本": "App 版本",
    "Flavor": "Flavor",
    "環境": "環境",
    "嚴重度": "嚴重度",
    "已處理": "已處理",
    "發生畫面": "發生畫面",
    "安裝識別碼": "安裝識別碼",
    "IP": "IP",
    "事件列表": "事件列表",
    "發生時間": "發生時間",
    "匿名": "匿名",
}
